import React from 'react'
import {
    TrainingsOverviewMetaProps,
    AllocationsOverviewMetaProps,
    AdminHubMetaProps,
    AdminSettingsMetaProps,
    AdminTrainingsMetaProps,
    AreaFormModalMetaProps,
    AssignTrainingFormModalMetaProps,
    ConfirmationModalMetaProps,
    DeleteAreaMetaProps,
    DeleteDutyMetaProps,
    DeleteEventMetaProps,
    DeletePreferenceMetaProps,
    DeleteFlagMetaProps,
    DeleteShiftMetaProps,
    DocumentViewerMetaProps,
    DuplicateAreaModalMetaProps,
    DuplicateEventModalMetaProps,
    DutyCardMetaProps,
    DutyFormModalMetaProps,
    DutyMetaProps,
    EventCardMetaProps,
    EventDetailMetaProps,
    EventFormModalMetaProps,
    EventsMetaProps,
    FooterMetaProps,
    HeaderMetaProps,
    HomeMetaProps,
    LoadingSpinnerMetaProps,
    LoginMetaProps,
    Nav,
    PreferenceCardMetaProps,
    PreferenceFormModalMetaProps,
    PreferenceMetaProps,
    FlagCardMetaProps,
    FlagFormModalMetaProps,
    FlagMetaProps,
    FlagCategoryFormModalMetaProps,
    UpdateFlagCategoryFormMetaProps,
    DeleteFlagCategoryMetaProps,
    ShiftFormModalMetaProps,
    DuplicateShiftModalMetaProps,
    CopyShiftAllocationsModalMetaProps,
    CompletionQuestionsModalMetaProps,
    TermsAndConditionsMetaProps,
    TrainingFormModalMetaProps,
    TrainingListMetaProps,
    TrainingModulePageMetaProps,
    UnsupportedModuleViewerMetaProps,
    UpdateAreaFormMetaProps,
    UpdateDutyFormMetaProps,
    UpdateEventFormMetaProps,
    UpdatePreferenceFormMetaProps,
    UpdateFlagFormMetaProps,
    UpdateShiftFormMetaProps,
    UpdateTrainingFormMetaProps,
    VideoPlayerMetaProps,
    VolunteerCardMetaProps,
    VolunteerFormModalMetaProps,
    VolunteerProfileMetaProps,
    VolunteersMetaProps,
    VolunteerTrainingPageDetailsMetaProps,
    VolunteerTrainingPageMetaProps,
    VolunteerPoliciesMetaProps,
    TrainingModuleMetaProps,
    AnnouncementMetaProps,
    AnnouncementFormModalMetaProps,
    AnnouncementViewModalMetaProps,
    BulkTrainingAssignmentFormMetaProps,
    ShiftAssignmentFormMetaProps,
    VolunteerFiltersWithConflictProps,
    UserFormModalMetaProps,
    UpdateUserFormMetaProps,
    DeleteUserMetaProps,
    LeadAssignModalPropsMeta,
    AccessColorMetaProps,
    AccessColorFormModalMetaProps,
    CoreTeamMetaProps,
    CoreTeamStatsMetaProps,
    CoreTeamTableMetaProps,
    RejectedCoreTeamTableMetaProps,
    CoreTeamFormModalMetaProps,
    CoreTeamAddModalMetaProps,
    Role,
    TrainingSequenceEditMetaProps,
    MaxChartSize,
    ManagementAnalyticsMetaProps,
    AnalyticsTab,
    VolunteerOverviewMetaProps,
    DashboardMetaProps,
    InternationalRegisterationsMetaProps,
    CoreStreamOverviewMetaProps,
    VolunteerStatsTableOverviewMetaProps,
    DidarAcknowledgementOverviewMetaProps,
    EmailCampaignsMetaProps,
    EmailCampaignFormMetaProps,
    EmailCampaignPreviewMetaProps,
    ShiftMoveModalMetaProps,
    VolunteerUploadDocumentFormMetaProps,
    AllocationStatusPageMetaProps,
    CheckInPageMetaProps,
    DutyStatusOverviewMetaProps,
    QuickAllocateModalMetaProps,
    LiveOperationsMetaProps,
    LiveStatusTab,
    LoginFormMetaProps,
    ForgetPasswordMetaProps,
    ResetPasswordMetaProps,
    SignupMetaProps,
    VerifyEmailMetaProps,
    HouseholdSelectionMetaProps,
    CheckInLoginFormMetaProps,
    PublicFormFillMetaProps,
    PublicFormsMetaProps,
    GuidelineFormModalMetaProps,
    AdminGuidelinesMetaProps,
    VolunteerGuidelinesMetaProps,
    GuidelineDetailsMetaProps,
    DirectorVolunteerMetaProps
} from './types'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from '../icons'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'
const IIUK_BASE_URL = process.env.REACT_APP_IIUK_BASE_URL || 'https://iiuk.org'

export const ROLE_MAP: { [key in Role]: string } = {
    volunteer: 'Volontär',
    lead: 'Ledare',
    super_lead: 'Huvudledare',
    allocating_lead: 'Placeringsledare',
    reallocation_manager: 'Omplaceringsansvarig',
    core_team: 'Kärnteam',
    core_team_approver: 'Kärnteamgodkännare',
    hr_team_member: 'HR-medarbetare',
    hr_deputy: 'HR-ställföreträdare',
    hr_admin: 'HR-administratör',
    admin: 'Administratör',
    checkin_volunteer: 'Incheckningsvolontär',
    checkin_admin: 'Incheckningsadministratör',
    lead_with_stats: 'Ledare med statistik',
    jv_exec: 'JV Exec',
    jv_lead: 'JV Lead',
    iv_director: 'IV Director',
    iv_deputy_director: 'IV Deputy Director'
}

const HeaderNav: Nav = {
    home: { title: 'Hem', path: `/` },
    profile: { title: 'Profil', path: `/profile` },
    trainings: { title: 'Min utbildning', path: '/volunteer/training' },
    policies: { title: 'Policyer', path: '/volunteer/policies' },
    events: { title: 'Evenemang', path: '/events', show: (user) => user.permissions?.includes('view_events') && user.permissions.includes('view_admin_hub') },
    check_in: { title: 'Incheckning', path: '/admin/check-in', show: (user) => user.permissions?.includes('manage_check_ins') },
    coreTeam: { title: 'Kärnteam', path: '/core-team', show: (user) => user.permissions?.includes('view_core_team') },
    admin: { title: 'Admin', path: `/admin`, show: (user) => user.permissions?.includes('view_admin_hub') },
    faq: { title: 'FAQ', path: 'https://iv.iiuk.org/vms-faq/' },
}

export const HeaderMeta: HeaderMetaProps = {
    title: 'Volontärhanteringssystem',
    themeToggleLightLabel: 'Växla till ljust läge',
    themeToggleDarkLabel: 'Växla till mörkt läge',
    themeToggleSystemLabel: 'Använd systemtema',
    languageSelectorLabel: 'Välj språk',
    logout: 'Logga ut',
    loggingOutText: 'Loggar ut...',
    nav: HeaderNav
}

export const FooterMeta: FooterMetaProps = {
    nav: {
        termsAndCondition: 'Användarvillkor',
        privacyNotice: 'Integritetspolicy'
    },
    version: 2026,
    copyRight: 'Alla rättigheter förbehållna'
}

export const TermsAndConditionsMeta: TermsAndConditionsMetaProps = {
    title: 'Volontärdatasamtycke & Integritetspolicy',
    content: `Genom att registrera dig bekräftar och godkänner du att Ismaili Volunteers VMS kommer att samla in och använda dina personuppgifter för att administrera volontärarbete, inklusive att matcha dig till lämpliga uppgifter och hantera din utbildning.

**Vad vi lagrar**: Vi kommer endast att lagra relevant volontärinformation, vilket kan inkludera fullständigt namn, e-postadress, mobilnummer, åldersgrupp, uppgiftspreferenser och färdigheter. Om du har genomgått en bakgrundskontroll (Disclosure & Barring Services) kan vi även registrera denna information.

**Delning av dina kontaktuppgifter (för volontärändamål)**: För att stödja volontäraktiviteter kan dina kontaktuppgifter delas med relevant(a) teamledare inom vår kommitté eller med relevanta institutionskontakter (där det är lämpligt) så att de kan kontakta dig gällande volontäruppgifter, scheman, uppdateringar och operativa krav.

**Utbildnings- och uppgiftsloggar**: Du förstår att din utbildningsaktivitet (t.ex. genomförande av inlärnings-/utbildningsvideor) och ditt deltagande/dina tilldelningar av uppgifter kan registreras och loggas på din volontärprofil av operativa, säkerhets- och efterlevnadsskäl.

**Dataskydd**: Vi kommer att behandla och lagra dina uppgifter i enlighet med gällande regler och föreskrifter, med hjälp av lämpliga tekniska och organisatoriska säkerhetsåtgärder. Uppgifterna kommer endast att sparas så länge som det är nödvändigt för volontäradministration och juridiska/efterlevnadskrav.\n\nGenom att acceptera bekräftar jag att jag har läst och godkänner ovanstående och samtycker till att mina uppgifter behandlas för volontäradministration enligt beskrivningen ovan.`,
    agreeButton: 'Jag godkänner',
    disagreeButton: 'Jag godkänner inte'
}


export const AdminHubMeta: AdminHubMetaProps = {
    title: 'Admin Hub',
    description: 'Få tillgång till alla administrativa verktyg och hanteringsfunktioner',
    dashboardTitle: 'Instrumentpanel',
    dashboardDescription: 'Översikt över användare och volontärer',
    eventsTitle: 'Evenemang',
    eventsDescription: 'Skapa och hantera evenemang, områden och pass',
    volunteersTitle: 'Volontärer',
    volunteersDescription: 'Hantera volontärprofiler och tilldelningar',
    trainingsTitle: 'Utbildningar',
    trainingsDescription: 'Skapa och hantera utbildningsinnehåll och moduler',
    dutiesTitle: 'Uppgifter',
    dutiesDescription: 'Definiera och hantera uppgiftstyper för pass',
    preferencesTitle: 'Preferenser',
    preferencesDescription: 'Hantera volontärers preferenser och tillgänglighet',
    flagsTitle: 'Flaggor',
    flagsDescription: 'Hantera volontärers flaggor och attribut',
    settingsTitle: 'Systeminställningar',
    settingsDescription: 'Konfigurera systemövergripande inställningar och utför massåtgärder',
    announcementsTitle: 'Meddelanden',
    announcementsDescription: 'Publicera meddelanden för att hålla alla volontärer uppdaterade',
    userTitle: 'Användarhantering',
    userDescription: 'Hantera användare och roller med åtkomstkontroll',
    accessColorTitle: 'Åtkomstfärger',
    accessColorDescription: 'Hantera åtkomstfärger för att kontrollera volontärers evenemangsåtkomst.',
    emailCampaignsTitle: 'E-postkampanjer',
    emailCampaignsDescription: 'Skapa och skicka e-postutskick till volontärer',
    formsTitle: 'Forms',
    formsDescription: 'Create public forms and review submitted responses',
    miTitle: 'Statistik',
    miDescription: 'Sammanfattade insikter och analys',
    internationalRegisterationTitle: 'Icke-IIUK-registreringar',
    internationalRegisternationDescription: 'Hantera Icke-IIUK volontärregistreringar.',
    allocationStatusTitle: 'Uppgiftsacceptans',
    allocationStatusDescription: 'Visa och hantera volontärers status för att acceptera/tacka nej till uppgifter',
    checkInTitle: 'Incheckning',
    checkInDescription: 'Skanna märken för att checka in volontärer för deras uppgifter',
    eventDayTitle: 'Live-evenemangsdrift',
    eventDayDescription: 'Övervaka volontärers närvaro i realtid, passtÄckning och kritiska operativa mätvärden',
    userLogTitle: "Användarlogg",
    userLogDescription: "Övervaka användaraktivitet",
    guidelineTitle: "Riktlinjer",
    guidelineDescription: "Skapa och hantera riktlinjeinnehåll",
    JvTitle: "Juniorvolontärpoäng",
    JVDescription: "Hantera poäng som juniorvolontärer har tjänat",
    directorVolunteerTitle: "Volontärer i din jamat khana",
    directorVolunteerDescription: "Visa alla volontärer från din jamat khana."
}

export const PublicFormsMeta: PublicFormsMetaProps = {
    title: 'Forms',
    description: 'Create public forms and review responses submitted through shared links',
    backButton: 'Back to Admin Hub',
    createButton: 'Create Form',
    errorTitle: 'Something went wrong',
    noFormsMessage: 'No forms have been created yet.',
    publicUrlLabel: 'Public URL',
    copyLinkButton: 'Copy Link',
    copiedText: 'Copied',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewResultsButton: 'View Results',
    hideResultsButton: 'Hide Results',
    submissionsTitle: 'Responses',
    noSubmissionsMessage: 'No responses have been submitted yet.',
    submittedAtLabel: 'Submitted',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    submissionsCountLabel: 'responses',
    titleLabel: 'Title',
    slugLabel: 'Custom URL',
    overrideUrlLabel: 'Override URL',
    overrideUrlHelpText: 'Optional. Leave this off to generate a random public link automatically. Turn it on to choose a friendly ending for the URL.',
    customUrlPlaceholder: 'volunteer-interest',
    descriptionLabel: 'Description',
    activeFormLabel: 'Make form live and allow submissions',
    fieldsLabel: 'Fields',
    addFieldButton: 'Add Field',
    fieldLabelLabel: 'Field Label',
    fieldTypeLabel: 'Field Type',
    requiredLabel: 'Required',
    optionsLabel: 'Options',
    optionPlaceholder: 'Option text',
    addOptionButton: 'Add Option',
    removeButton: 'Remove',
    saveButton: 'Save Form',
    savingButton: 'Saving...',
    createModalTitle: 'Create Form',
    editModalTitle: 'Edit Form',
    textTypeLabel: 'Single Line Text',
    emailTypeLabel: 'Email Address',
    checkboxTypeLabel: 'Checkbox Group',
    radioTypeLabel: 'Radio Group',
    selectTypeLabel: 'Dropdown Select',
    deleteTitle: 'Delete Form',
    deleteMessage: 'This will permanently delete the form and all submitted responses.',
    matchByLabel: 'Match volunteers by',
    matchedVolunteerColumn: 'Matched Volunteer',
    matchingLabel: 'Matching...',
    noMatchLabel: 'No match',
    selectMatchButton: (count: number) => `Select (${count})`,
    changeMatchButton: 'Change',
    matchModalTitle: 'Select Matched Volunteer',
    matchModalDescription: 'More than one volunteer matched this email address. Select the correct one.',
    matchIdColumn: 'ID',
    matchNameColumn: 'Name',
    matchEmailColumn: 'Email',
    matchSelectButton: 'Select',
    matchCloseButton: 'Close',
    approveAndAllocateButton: 'Approve & Assign',
    allocateModalTitle: 'Approve and Assign Volunteer',
    allocateEventLabel: 'Event',
    allocateAreaLabel: 'Area',
    allocateShiftLabel: 'Shift',
    allocateSelectEventPlaceholder: 'Select an event',
    allocateSelectAreaPlaceholder: 'Select an area',
    allocateNoShiftsMessage: 'No shifts found for this area.',
    approveAndAllocateConfirmButton: 'Approve & Assign',
    approveAndAllocatingButton: 'Approving...',
    approveAndAllocateSuccessMessage: 'Volunteer approved and assigned successfully.',
    allocateCloseButton: 'Close',
    exportLabel: 'Allow Exports',
    exportResultButton: 'Export Submissions',
    showQrCodeButton: 'Show QR Code',
    qrCodeModalTitle: 'Form QR Code',
    qrCodeModalDescription: 'Scan this code or share the link below to open the public form.',
    downloadPngButton: 'Download PNG',
    qrCodeCloseButton: 'Close'
}

export const PublicFormFillMeta: PublicFormFillMetaProps = {
    loadingText: 'Loading form...',
    errorTitle: 'Unable to load form',
    notFoundMessage: 'This form is not available.',
    requiredLabel: 'Required',
    submitButton: 'Submit',
    submittingText: 'Submitting...',
    successTitle: 'Response Submitted',
    successMessage: 'Thank you. Your response has been recorded.',
    selectPlaceholder: 'Select an option'
}

export const AdminSettingsMeta: AdminSettingsMetaProps = {
    title: 'Systeminställningar',
    description: 'Hantera systemövergripande konfigurationer och utför administrativa åtgärder',
    globalSettingsTitle: 'Globala inställningar',
    globalSettingsDescription: 'Systemövergripande flaggor och konfigurationsalternativ',
    visitAnnouncedTitle: 'Besök tillkännagivet',
    visitAnnouncedDescription: 'Växla om besöket har tillkännagivits offentligt. Detta påverkar vilket innehåll som är synligt för användare.',
    internationalSignupsEnabledTitle: 'Internationella registreringar aktiverade',
    internationalSignupsEnabledDescription: 'Växla om internationella besökare får registrera sig. Detta påverkar tillgängligheten för internationella besökares inloggning och registreringsalternativ.',
    showShiftInfoTitle: 'Visa passinformation',
    showShiftInfoDescription: 'Växla om information om pass/uppgiftstilldelning ska visas på startsidan för volontärer.',
    localModeTitle: 'Lokalt läge',
    localModeDescription: 'Aktivera lokal streckkodssökning vid incheckning. När detta är aktiverat hämtas streckkoder från den lokala databasen istället för det externa API:et.',
    trainingManagementTitle: 'Utbildningshantering',
    trainingManagementDescription: 'Massåtgärder för att hantera volontärutbildningar',
    assignMandatoryTitle: 'Tilldela obligatoriska utbildningar',
    assignMandatoryDescription: 'Tilldela automatiskt alla obligatoriska utbildningar till volontärer som inte har dem ännu',
    assignButton: 'Tilldela alla volontärer',
    assigningText: 'Tilldelar...',
    profileManagementTitle: 'Profilhantering',
    profileManagementDescription: 'Massåtgärder för att hantera volontärprofiler',
    clearProfilesTitle: 'Begär profiluppdateringar',
    clearProfilesDescription: 'Rensa alla profilers inlämningstidsstämplar för att kräva att alla volontärer granskar och skickar in sina profiler igen',
    clearProfilesButton: 'Begär alla profiler',
    clearingProfilesText: 'Rensar...'
}

export const HomeMeta: HomeMetaProps = {
    greeting: (userName: string) => `Hej ${userName},`,
    motd: 'Välkommen till Ismaili Volunteers VMS-portal. Denna plattform har skapats för att stödja våra volontärer genom att erbjuda ett gemensamt utrymme för att få tillgång till utbildningsresurser, hålla koll på lärande och samordna volontäruppdrag på ett genomtänkt sätt. Vi uppskattar den tid, omtanke och det engagemang du fortsätter att ge genom din Khidma (tjänst).',
    travelInfo: 'Om du redan planerar att resa och vill vara volontär, vänligen registrera ditt intresse. Volontärarbete bygger på personliga arrangemang, och alla resor, boende, visum och relaterade krav måste ordnas självständigt.',
    visitAnnouncedProfileTitle: 'Registrera dig som volontär (Europa Didar (Berlin))',
    visitAnnouncedProfileMessage: 'Vänligen registrera ditt intresse att vara volontär för den kommande Europa Didar (Berlin).',
    visitAnnouncedCompleteButton: 'Slutför registrering',
    profileIncompleteWarningTitle: 'Slutför din profil',
    profileIncompleteWarningMessage: 'Vänligen slutför din profil för att få tillgång till alla funktioner.',
    completeProfileButton: 'Slutför profil',
    policyIncompleteWarningTitle: 'Åtgärd krävs: Granska policyer',
    policyIncompleteWarningMessage: (count: number) => `Du har ${count} ${count !== 1 ? 'policyer' : 'policy'} som kräver din granskning och bekräftelse.`,
    reviewPoliciesButton: 'Granska policyer',
    volunteerMessagesTitle: 'Volontärmeddelanden',
    priorityLabel: 'Prioritet',
    viewButton: 'Visa',
    previousButton: 'Föregående',
    nextButton: 'Nästa',
    pageLabel: 'Sida',
    assignedTrainingsTitle: 'Tilldelad utbildning',
    noIncompleteTrainingsMessage: 'All tilldelad utbildning är slutförd!',
    incompleteTrainingsMessage: (count: number) => `Du har ${count} ofullständig${count !== 1 ? 'a' : ''} utbildning${count !== 1 ? 'ar' : ''}.`,
    viewTrainingsButton: 'Visa min utbildning',
    assignedShiftsTitle: 'Tilldelade uppgifter',
    noAssignedShiftsMessage: 'Du har inga tilldelade uppgifter för närvarande.',
    acceptButton: 'Acceptera',
    declineButton: 'Tacka nej',
    pendingLabel: 'Väntande',
    acceptedLabel: 'Accepterad',
    declinedLabel: 'Tackat nej',
    loadingShiftsText: 'Laddar dina pass...',
    shiftTimeLabel: 'Passtid',
    eventLabel: 'Evenemang',
    areaLabel: 'Område',
    shiftLabel: 'Pass',
    shiftLeadLabel: 'Ledare',
    declineHelperText: 'Att välja att tacka nej låter oss veta att du inte är tillgänglig för denna uppgift. Tack för att du hjälper oss att planera i förväg.',
    dutiesNotYetAssignedMessage: 'Uppgifter kommer att tilldelas i sinom tid. Vänligen återkom regelbundet för uppdateringar.',
    // Accept/Decline modal
    acceptThankYouMessage: 'Tack för att du accepterar din seva.',
    confirmAcceptMessage: 'Vänligen bekräfta att du vill acceptera denna seva.',
    tknCheckboxLabel: 'Jag skulle vilja erbjuda denna uppgift som en del av TKN. Markera endast denna ruta om du erbjöd en TKN Niyat år 2008 och/eller 2018.',
    ivTieScarfLabel: 'För att tjäna under Didar krävs IV-slipsen/sjalen. Har du för närvarande en?',
    ivTieScarfYes: 'Ja',
    ivTieScarfNo: 'Nej',
    confirmButton: 'Bekräfta',
    goBackButton: 'Gå tillbaka',
    declineModalTitle: 'Tacka nej till uppgift',
    declineReasonLabel: 'Anledning till att tacka nej',
    declineReasonPlaceholder: 'Vänligen välj en anledning',
    declineDetailsLabel: 'Ytterligare detaljer (valfritt)',
    declineDetailsPlaceholder: 'Vänligen ange eventuell ytterligare information...',
    declineReasons: [
        'Tiden passar inte (ett annat pass kan erbjudas, i mån av plats)',
        'Jag vill inte utföra just denna uppgift (ett annat pass kan erbjudas, i mån av plats)',
        'Kan inte engagera mig just nu (jag kommer att besöka VRC på dagen)',
        'Jag vill inte längre fortsätta på grund av personliga skäl'
    ],
    submitDeclineButton: 'Skicka',
    cancelButton: 'Avbryt',
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid'
}

export const EventsMeta: EventsMetaProps = {
    title: 'Evenemang',
    description: 'Bläddra och hantera alla kommande evenemang',
    errorTitle: 'Fel vid inläsning av evenemang',
    noEventsMessage: 'Inga evenemang hittades',
    noFilteredEventsMessage: 'Inga evenemang matchar det aktuella filtret',
    filterLabel: 'Snabbfilter',
    filterPlaceholder: 'Sök evenemang efter namn...',
    filterPresetsLabel: 'Förval',
    clearFilterButton: 'Rensa',
    createButton: 'Skapa nytt evenemang'
}
export const VolunteersMeta: VolunteersMetaProps = {
    title: 'Volontärer',
    description: 'Bläddra och hantera alla volontärer',
    errorTitle: 'Fel vid inläsning av volontär',
    noEventsMessage: 'Ingen volontär hittades',
    createButton: 'Skapa ny volontär'
}
export const DutyMeta: DutyMetaProps = {
    title: 'Tillgängliga uppgifter',
    description: 'Bläddra och hantera alla tillgängliga uppgifter',
    errorTitle: 'Fel vid inläsning av uppgifter',
    noDutyMessage: 'Inga uppgifter hittades',
    dutySearchPlaceHolder: 'Sök uppgift efter titel...',
    createButton: 'Skapa ny uppgift'
}

export const LoadingSpinnerMeta: LoadingSpinnerMetaProps = {
    loadingText: 'Laddar...'
}

export const LoginMeta: LoginMetaProps = {
    ukResidentLoginButton: 'Logga in via IIUK',
    internationalVisitorLoginButton: 'Volontärcommunity (icke-IIUK-registrerad)',
    checkInLoginLink: 'Check-in-inloggning',
    helpText: () => <>{`För att få tillgång till VMS, vänligen logga in med dina IIUK-inloggningsuppgifter.

Om du ännu inte är registrerad på IIUK, eller inte kan komma åt ditt konto, vänligen använd alternativet "Glömt lösenord" för att få tillbaka åtkomst till IIUK först. När din IIUK-åtkomst är återställd kommer du att kunna logga in på VMS.

Om du fortsätter att uppleva problem med att logga in, eller om du har några frågor, vänligen kontakta oss på`} <a href="mailto:ivc@iiuk.org" className='underline text-primary-600'>ivc@iiuk.org</a>.</>,
    pendingApprovalTitle: 'Kontot väntar på godkännande'
}

export const EventCardMeta: EventCardMetaProps = {
    dateLabel: 'Datum',
    timeLabel: 'Tid',
    locationLabel: 'Plats',
    areasLabel: 'Områden',
    addressLabel: 'Adress',
    areasSingular: 'område',
    areasPlural: 'områden',
    viewDetailsButton: 'Visa detaljer',
    visibleLabel: 'Synlig',
    perAreaLabel: 'Per område',
    shiftsVisibleTooltip: 'Godkända pass i detta evenemang är synliga för volontärer (evenemangsnivåns synlighet aktiverad)',
    shiftsPerAreaTooltip: 'Passens synlighet styrs på områdesnivå - kontrollera enskilda områden'
}
export const VolunteerCardMeta: VolunteerCardMetaProps = {
    dateLabel: 'Datum',
    timeLabel: 'Tid',
    locationLabel: 'Plats',
    areasLabel: 'Områden',
    addressLabel: 'Adress',
    areasSingular: 'område',
    areasPlural: 'områden',
    viewDetailsButton: 'Visa detaljer'
}
export const DutyCardMeta: DutyCardMetaProps = {
    'nameLabel': 'Uppgiftsnamn'
}

export const PreferenceMeta: PreferenceMetaProps = {
    title: 'Tillgängliga preferenser',
    description: 'Bläddra och hantera alla volontärpreferenser',
    errorTitle: 'Fel vid inläsning av preferenser',
    noPreferenceMessage: 'Inga preferenser hittades',
    preferenceSearchPlaceHolder: 'Sök preferens efter namn eller kategori...',
    createButton: 'Skapa ny preferens'
}

export const PreferenceCardMeta: PreferenceCardMetaProps = {
    nameLabel: 'Preferensnamn',
    categoryLabel: 'Kategori',
    descriptionLabel: 'Beskrivning'
}

export const EventDetailMeta: EventDetailMetaProps = {
    backToEventsButton: 'Tillbaka till evenemang',
    areasTitle: 'Områden',
    noAreasMessage: 'Inga områden hittades för detta evenemang',
    shiftsTitle: 'Pass',
    noShiftsMessage: 'Inga pass tilldelade detta område',
    loadingText: 'Laddar...',
    errorTitle: 'Fel',
    dateLabel: 'Datum',
    timeLabel: 'Tid',
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid',
    capacityLabel: 'Kapacitet',
    volunteersLabel: 'Volontärer',
    maxVolunteersLabel: 'Max volontärer',
    descriptionLabel: 'Beskrivning',
    locationLabel: 'Plats',
    addressLabel: 'Adress',
    showShiftsButton: 'Visa pass',
    hideShiftsButton: 'Dölj pass',
    leadsTitle: "Evenemangsledare",
    leadNameTitle: "Ledarnamn",
    deputyLeadNameTitle: "Ställföreträdande ledare",
    contactTitle: "Kontakt",
    editEventButton: 'Redigera evenemang',
    copyShiftAllocationsButton: 'Copy allocations',
    exportShiftRegionStatusButton: 'Exportera passstatus',
    exportingShiftRegionStatusButton: 'Exporterar...',
    exportShiftRegionStatusError: 'Det gick inte att exportera passstatusdata',
    selectEmailCampaignsTitle: 'Välj e-postkampanjer',
    selectEmailCampaignsDescription: 'Välj vilka skickade e-postkampanjer som ska räknas för kolumnerna E-post skickad J/N i denna export.',
    selectEmailCampaignsCancelButton: 'Avbryt',
    selectEmailCampaignsExportButton: 'Exportera valda kampanjer',
    selectEmailCampaignsError: 'Välj minst en e-postkampanj för denna export.',
    emailCampaignLoadError: 'Det gick inte att läsa in e-postkampanjer',
    noEmailCampaignsMessage: 'Inga e-postkampanjer är tillgängliga att välja.',
    emailCampaignOptionDetails: (status, sentCount, createdAt) => `${status.replace('_', ' ')} • ${sentCount} skickade • Skapad ${new Date(createdAt).toLocaleDateString()}`,
    createAreaButton: 'Skapa nytt område',
    addShiftButton: 'Lägg till pass',
    required_volunteer_count_label: 'Krävda volontärer',
    allocation_count_label: "Tilldelade volontärer",
    leads_count_label: "Ledarpositioner",
    multi_allocation_count_label: "Med flera tilldelningar",
    accepted_allocations_label: 'Accepterad',
    rejected_allocations_label: 'Avvisad',
    pending_allocations_label: 'Väntande',
    visibleLabel: 'Synlig',
    visibleViaEventLabel: 'Synlig via evenemang',
    hiddenLabel: 'Dold',
    shiftsVisibleTooltip: 'Godkända pass i detta område är synliga för volontärer (områdesnivåns synlighet aktiverad)',
    shiftsVisibleViaEventTooltip: 'Godkända pass i detta område är synliga för volontärer (via evenemangsnivåns synlighet)',
    shiftsHiddenTooltip: 'Pass i detta område är dolda för volontärer (aktivera synlighet på områdes- eller evenemangsnivå)'
}

export const EventFormModalMeta: EventFormModalMetaProps = {
    title: 'Skapa nytt evenemang',
    nameLabel: 'Evenemangsnamn',
    namePlaceholder: 'Ange evenemangsnamn',
    organizerLabel: 'Arrangör',
    organizerPlaceholder: 'Ange arrangörsnamn',
    startDateLabel: 'Startdatum',
    endDateLabel: 'Slutdatum',
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid',
    locationLabel: 'Plats',
    locationPlaceholder: 'Ange platsens namn',
    addressLabel: 'Adress',
    addressPlaceholder: 'Ange fullständig adress',
    cityLabel: 'Stad',
    cityPlaceholder: 'Ange stad',
    countryLabel: 'Land',
    countryPlaceholder: 'Ange land',
    submitButton: 'Skapa evenemang',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa evenemanget. Vänligen försök igen.',
    leadNamePlaceholder: 'Ledarnamn',
    leadPhoneNumberPlaceHolder: 'Ledarens telefonnummer',
    deputyLeadNamePlaceHolder: 'Ställföreträdande ledarnamn',
    deputyLeadPhoneNumberPlaceHolder: 'Ställföreträdande ledarens telefonnummer',
    leadNameTitle: 'Ledaruppgifter',
    leadcontactTitle: 'Ledarens telefonnummer',
    deputyLeadNameTitle: 'Ställföreträdande ledaruppgifter',
    deputyLeadcontactTitle: 'Ställföreträdande ledarens telefonnummer',
    required_volunteer_count_title: 'Krävt volontärantal',
    require_walkie_talkie_label: 'Kräver walkie-talkie',
    shiftsVisibleLabel: 'Pass synliga för volontärer',
    shiftsVisibleDescription: 'När detta är aktiverat kommer godkända pass i detta evenemang att vara synliga för volontärer för att acceptera/tacka nej. Pass måste också godkännas (låsas) för att vara synliga.',
    includeInDuplicateChecksLabel: 'Inkludera i dubblettkontroller',
    includeInDuplicateChecksDescription: 'När detta är aktiverat kommer tilldelningar i detta evenemang att räknas med i volontärers dubblettkontroller. Inaktivera för evenemang som inte ska påverka dubbletträkning.',
}

export const DuplicateEventModalMeta: DuplicateEventModalMetaProps = {
    title: 'Duplicera evenemang',
    nameLabel: 'Evenemangsnamn',
    namePlaceholder: 'Ange evenemangsnamn',
    startDateLabel: 'Startdatum',
    endDateLabel: 'Slutdatum',
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid',
    submitButton: 'Duplicera evenemang',
    submittingButton: 'Duplicerar...',
    cancelButton: 'Avbryt',
    errorMessage: 'Kunde inte duplicera evenemanget. Vänligen försök igen.',
    description: 'Detta kommer att skapa en kopia av evenemanget inklusive alla områden och pass, men inte volontärtilldelningar. Du kan ändra namnet och datumen för det nya evenemanget.'
}

export const VolunteerFormModalMeta: VolunteerFormModalMetaProps = {
    title: 'Volontärinformation',
    nameLabel: 'Förnamn',
    namePlaceholder: 'Ange förnamn',
    lastNameLabel: 'Efternamn',
    lastNamePlaceholder: 'Ange efternamn',
    secondLastNameLabel: 'Andra efternamn',
    secondLastNamePlaceholder: 'Ange andra efternamn (valfritt)',
    genderLabel: 'Kön',
    dobLabel: 'Födelsedatum',
    contactLabel: 'Telefonnummer',
    contactPlaceholder: 'Ange telefonnummer',
    countryCodeLabel: 'Landskod',
    EmailLabel: 'E-post',
    EmailPlaceholder: 'Ange e-postadress',
    CountryofResidence: 'Bosättningsland',
    countryOfBirthLabel: 'Födelseland',
    Jamatkhana: 'Jamatkhana',
    FamilyOriginLabel: 'Familjens ursprung',
    serviceLocationLabel: 'Tjänstgöringsplats',
    serviceRecordLabel: 'Vänligen meddela oss om du vill tjänstgöra som uniformerad volontär eller icke-uniformerad volontär',
    languagesLabel: 'Språk',
    supportNeedsLabel: 'Särskilda stödbehov',
    supportNeedsPlaceholder: 'Vänligen meddela oss om du behöver någon särskild hjälp',
    volunteerStatusLabel: 'Volontärstatus',
    ismailiLabel: 'Ismaili',
    multiFaithFamilyLabel: 'Flerreligiös familj',
    registeredVolunteerLabel: 'Registrerad volontär',
    eligibleForDutyLabel: 'Kvalificerad för uppgift',
    preferencesLabel: 'Preferenser',
    flagsLabel: 'Volontärers ytterligare detaljer',
    submitButton: 'Skicka',
    submittingButton: 'Skickar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skicka profilen. Vänligen försök igen.',
    volunteerForVisit: 'Vill du vara volontär under Didar?',
    availabilityLabel: 'Vänligen ange hur du vill hjälpa till (du kan välja flera alternativ):',
    negativeListLabel: "Kan inte utföra arbetsuppgifter",
    registrationNote: () => <>
        Vänligen se till att du har registrerat dig för Europa Didar (Berlin) (om du är berättigad) via <Link to={`${IIUK_BASE_URL}`} className='font-medium underline inline-block break-inside-avoid' target='_blank'>IIUK <ExternalLinkIcon className='inline w-3.5 h-3.5' /></Link> eller The Ismaili App.<br />
        Denna registrering är <i>endast</i> för volontärhantering och utgör <i>inte</i> en registrering för själva Europa Didar (Berlin).
    </>,
    registrationAckLabel: 'Jag förstår',
    successMessage: 'Din volontärprofil har skickats in.',
}

export const DutyFormModalMeta: DutyFormModalMetaProps = {
    title: 'Skapa ny uppgift',
    nameLabel: 'Namn',
    negativeListMemberLabel: 'Lägg till i negativlistan',
    namePlaceholder: 'Ange uppgiftsnamn',
    submitButton: 'Skapa uppgift',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa uppgiften. Vänligen försök igen.'
}

export const PreferenceFormModalMeta: PreferenceFormModalMetaProps = {
    title: 'Skapa ny preferens',
    nameLabel: 'Namn',
    namePlaceholder: 'Ange preferensnamn',
    categoryLabel: 'Kategori',
    categoryPlaceholder: 'Ange kategori',
    descriptionLabel: 'Beskrivning',
    descriptionPlaceholder: 'Ange beskrivning',
    submitButton: 'Skapa preferens',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa preferensen. Vänligen försök igen.'
}

export const DeleteDutyMeta: DeleteDutyMetaProps = {
    deleteButtonText: 'Ta bort uppgift',
    confirmTitle: 'Ta bort uppgift',
    confirmMessage: 'Är du säker på att du vill ta bort denna uppgift? Denna åtgärd kan inte ångras och kommer att ta bort den valda uppgiften.'
}

export const DeletePreferenceMeta: DeletePreferenceMetaProps = {
    deleteButtonText: 'Ta bort preferens',
    confirmTitle: 'Ta bort preferens',
    confirmMessage: 'Är du säker på att du vill ta bort denna preferens? Denna åtgärd kan inte ångras och kommer att ta bort den valda preferensen.'
}

export const FlagMeta: FlagMetaProps = {
    title: 'Tillgängliga flaggor',
    description: 'Bläddra och hantera alla volontärflaggor',
    errorTitle: 'Fel vid inläsning av flaggor',
    noFlagMessage: 'Inga flaggor hittades',
    flagSearchPlaceHolder: 'Sök flagga efter namn...',
    createButton: 'Skapa ny flagga',
    categorySectionTitle: 'Flaggkategorier',
    noCategoryMessage: 'Inga kategorier hittades',
    createCategoryButton: 'Skapa ny kategori'
}

export const CoreTeamMeta: CoreTeamMetaProps = {
    title: 'Kärnteam',
    description: 'Visa och hantera kärnteammedlemmar i alla strömmar',
    createButton: 'Lägg till kärnteammedlem',
    errorTitle: 'Fel vid inläsning av kärnteam',
    noDataMessage: 'Inga kärnteammedlemmar hittades',
    loadingText: 'Laddar kärnteammedlemmar...'
}

export const CoreTeamStatsMeta: CoreTeamStatsMetaProps = {
    statsTitle: 'Statistik',
    showStatsButton: 'Visa statistik',
    hideStatsButton: 'Dölj statistik',
    genderTitle: 'Kön',
    regionTitle: 'Region',
    familyOriginTitle: 'Familjens ursprung',
    londonLabel: 'London',
    notLondonLabel: 'Inte London',
    excludedReservedNote: '(Reserverad nivå exkluderad)',
    otherLabel: 'Annat'
}

export const CoreTeamTableMeta: CoreTeamTableMetaProps = {
    idColumn: 'ID',
    nameColumn: 'Namn',
    streamsColumn: 'Strömmar',
    roleColumn: 'Roll',
    tierColumn: 'Nivå',
    phoneColumn: 'Telefon',
    emailColumn: 'E-post',
    ismailiColumn: 'Ismaili',
    familyOriginColumn: 'Familjens ursprung',
    ageBandColumn: 'Åldersgrupp',
    notesColumn: 'Anteckningar',
    duplicationsColumn: 'Dubbletter',
    submittedByColumn: 'Skickad av',
    statusColumn: 'Godkännandestatus',
    activityStatusColumn: 'Aktivitetsstatus',
    actionsColumn: 'Åtgärder',
    approvedStatus: 'Godkänd',
    pendingStatus: 'Inskickad',
    activeStatus: 'Aktiv',
    onHoldStatus: 'Pausad',
    approveButton: 'Godkänn',
    rejectButton: 'Avvisa',
    yesLabel: 'Ja',
    noLabel: 'Nej',
    viewAllocationsButton: (count: number) => `Visa dubbletter (${count})`,
    streamFilterLabel: 'Ström',
    allStreamsLabel: 'Alla strömmar',
    tierFilterLabel: 'Nivå',
    allTiersLabel: 'Alla nivåer',
    statusFilterLabel: 'Godkännandestatus',
    allStatusLabel: 'Alla statusar',
    activityStatusFilterLabel: 'Aktivitetsstatus',
    allActivityStatusLabel: 'Alla',
    duplicationsFilterLabel: 'Dubbletter',
    anyDuplicationsLabel: 'Vilka som helst',
    hasDuplicationsLabel: 'Har dubbletter',
    noDuplicationsLabel: 'Inga dubbletter',
    putOnHoldButton: 'Pausa',
    makeActiveButton: 'Gör aktiv',
    selectedCountLabel: (count: number) => `${count} vald(a)`,
    clearSelectionLabel: 'Rensa markering',
    bulkApproveLabel: 'Godkänn',
    bulkApprovingLabel: 'Godkänner...',
    bulkRejectLabel: 'Avvisa',
    bulkRejectingLabel: 'Avvisar...',
    bulkUnapproveLabel: 'Ångra godkännande',
    bulkUnapprovingLabel: 'Ångrar godkännande...',
    bulkDeleteLabel: 'Ta bort',
    bulkDeletingLabel: 'Tar bort...',
    bulkPutOnHoldLabel: 'Pausa',
    bulkPuttingOnHoldLabel: 'Pausar...',
    bulkMakeActiveLabel: 'Gör aktiv',
    bulkMakingActiveLabel: 'Gör aktiv...',
    previousPageLabel: 'Föregående',
    nextPageLabel: 'Nästa',
    pageInfoLabel: (start: number, end: number, total: number) => `Visar ${start}-${end} av ${total}`,
    rowsPerPageLabel: 'Rader per sida',
    exportButton: 'Exportera till CSV'
}

export const RejectedCoreTeamTableMeta: RejectedCoreTeamTableMetaProps = {
    title: 'Avvisade kärnteamsposter',
    nameColumn: 'Namn',
    streamsColumn: 'Strömmar',
    roleColumn: 'Roll',
    tierColumn: 'Nivå',
    rejectedByColumn: 'Avvisad av',
    rejectedDateColumn: 'Avvisad datum',
    deleteButton: 'Ta bort',
    deletingButton: 'Tar bort...',
    noDataMessage: 'Inga avvisade poster hittades',
    searchPlaceholder: 'Sök avvisade poster...',
    clearFiltersButton: 'Rensa',
    exportButton: 'Exportera till CSV'
}

export const CoreTeamFormModalMeta: CoreTeamFormModalMetaProps = {
    title: 'Lägg till kärnteammedlem',
    volunteerLabel: 'Volontär',
    submittedByLabel: 'Skickad av',
    streamsLabel: 'Strömmar',
    streamsSelectedLabel: 'ström(mar) vald(a)',
    streamsRequiredError: 'Vänligen välj minst en ström',
    statusLabel: 'Aktivitetsstatus',
    activeStatus: 'Aktiv',
    onHoldStatus: 'Pausad',
    roleLabel: 'Roll',
    rolePlaceholder: 'Ange roll (t.ex. ExCo, PMO)',
    roleRequiredError: 'Roll krävs',
    tierLabel: 'Nivå',
    tierRequiredError: 'Nivå krävs',
    notesLabel: 'Anteckningar (valfritt)',
    notesPlaceholder: 'Ange eventuella ytterligare anteckningar',
    submitButton: 'Skicka för godkännande',
    submittingButton: 'Skickar...',
    cancelButton: 'Avbryt',
    errorMessage: 'Kunde inte lägga till kärnteammedlem. Vänligen försök igen.'
}

export const CoreTeamAddModalMeta: CoreTeamAddModalMetaProps = {
    title: 'Välj volontär att lägga till',
    nameSearchPlaceholder: 'Sök på namn...',
    emailSearchPlaceholder: 'Sök på e-post...',
    phoneSearchPlaceholder: 'Sök på telefon...',
    idSearchPlaceholder: 'Sök på ID...',
    searchButton: 'Sök',
    clearButton: 'Rensa',
    loadingText: 'Laddar volontärer...',
    pagesLabel: 'sidor',
    showingLabel: 'Visar',
    volunteersLabel: 'volontärer',
    noResultsMessage: 'Inga volontärer hittades som matchar din sökning',
    noVolunteersMessage: 'Alla volontärer är redan i kärnteamet',
    idColumn: 'ID',
    nameColumn: 'Namn',
    phoneColumn: 'Telefon',
    emailColumn: 'E-post',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Dubbletter',
    viewDuplicationsButton: (count: number) => `Visa (${count})`,
    actionColumn: 'Åtgärd',
    addButton: 'Lägg till',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte ladda volontärer. Vänligen försök igen.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Dubbletter för ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Passtilldelningar (${count})`,
    excludedAllocationsTitle: (count: number) => `Exkluderad från dubbletträkning (${count})`,
    excludedAllocationsDescription: 'Dessa tilldelningar är från evenemang som inte inkluderas i dubblettkontroller.',
    coreTeamAssignmentsTitle: (count: number) => `Kärnteamstilldelningar (${count})`,
    leadPositionsTitle: (count: number) => `Ledar-/Ställföreträdande ledarpositioner (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Exkluderade ledarpositioner (${count})`,
    excludedLeadPositionsDescription: 'Dessa ledarpositioner är från evenemang som inte inkluderas i dubblettkontroller.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Evenemang',
    areaColumn: 'Område',
    shiftColumn: 'Pass',
    dateTimeColumn: 'Datum/Tid',
    noDuplicationsMessage: 'Inga andra tilldelningar eller kärnteamstilldelningar hittades.',
    closeModalButton: 'Stäng',
    submittedStatus: 'Inskickad',
    approvedStatus: 'Godkänd',
    pendingStatus: 'Väntande',
    acceptedStatus: 'Accepterad',
    declinedStatus: 'Tackat nej',
    roleColumn: 'Roll',
    streamsColumn: 'Strömmar'
}

export const FlagCardMeta: FlagCardMetaProps = {
    nameLabel: 'Flaggnamn',
    descriptionLabel: 'Beskrivning',
    hiddenFromRegistrationLabel: 'Dold från registrering'
}

export const FlagFormModalMeta: FlagFormModalMetaProps = {
    title: 'Skapa ny flagga',
    nameLabel: 'Namn',
    categoryLabel: 'Kategori',
    categoryPlaceholder: 'Välj en kategori (valfritt)',
    noCategoryOption: 'Ingen kategori',
    namePlaceholder: 'Ange flaggnamn (t.ex. Brandsäkerhetsutbildad, Medicinsk personal)',
    descriptionLabel: 'Beskrivning',
    descriptionPlaceholder: 'Ange flaggbeskrivning',
    hasExpiryLabel: 'Har utgångsdatum',
    hiddenFromRegistrationLabel: 'Dölj från registreringsformuläret',
    submitButton: 'Skapa flagga',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa flaggan. Vänligen försök igen.'
}

export const UpdateFlagFormMeta: UpdateFlagFormMetaProps = {
    title: 'Uppdatera flagga',
    submitButton: 'Uppdatera flagga',
    submittingButton: 'Uppdaterar...'
}

export const DeleteFlagMeta: DeleteFlagMetaProps = {
    deleteButtonText: 'Ta bort flagga',
    confirmTitle: 'Ta bort flagga',
    confirmMessage: 'Är du säker på att du vill ta bort denna flagga? Denna åtgärd kan inte ångras och kommer att ta bort den valda flaggan.'
}

export const FlagCategoryFormModalMeta: FlagCategoryFormModalMetaProps = {
    title: 'Skapa ny kategori',
    nameLabel: 'Kategorinamn',
    namePlaceholder: 'Ange kategorinamn',
    submitButton: 'Skapa kategori',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    errorMessage: 'Kunde inte skapa kategorin. Vänligen försök igen.'
}

export const UpdateFlagCategoryFormMeta: UpdateFlagCategoryFormMetaProps = {
    title: 'Uppdatera kategori',
    submitButton: 'Uppdatera kategori',
    submittingButton: 'Uppdaterar...'
}

export const DeleteFlagCategoryMeta: DeleteFlagCategoryMetaProps = {
    deleteButtonText: 'Ta bort',
    confirmTitle: 'Ta bort kategori',
    confirmMessage: 'Är du säker på att du vill ta bort denna kategori? Flaggor i denna kategori kommer inte att tas bort, men kommer att sakna tilldelad kategori.'
}

export const ConfirmationModalMeta: ConfirmationModalMetaProps = {
    confirmButton: 'Ta bort',
    cancelButton: 'Avbryt',
    deletingButton: 'Tar bort...'
}

export const DeleteEventMeta: DeleteEventMetaProps = {
    deleteButtonText: 'Ta bort evenemang',
    confirmTitle: 'Ta bort evenemang',
    confirmMessage: 'Är du säker på att du vill ta bort detta evenemang? Denna åtgärd kan inte ångras och kommer att ta bort alla tillhörande områden, pass och tilldelningar.',
    detailDeleteButtonText: 'Ta bort evenemang'
}

export const UpdateEventFormMeta: UpdateEventFormMetaProps = {
    title: 'Redigera evenemang',
    submitButton: 'Uppdatera evenemang',
    submittingButton: 'Uppdaterar...'
}

export const UpdateDutyFormMeta: UpdateDutyFormMetaProps = {
    title: 'Redigera uppgift',
    submitButton: 'Uppdatera uppgift',
    submittingButton: 'Uppdaterar...'
}

export const UpdatePreferenceFormMeta: UpdatePreferenceFormMetaProps = {
    title: 'Redigera preferens',
    submitButton: 'Uppdatera preferens',
    submittingButton: 'Uppdaterar...'
}

export const AreaFormModalMeta: AreaFormModalMetaProps = {
    title: 'Skapa nytt område',
    nameLabel: 'Områdesnamn',
    namePlaceholder: 'Ange områdesnamn',
    submitButton: 'Skapa område',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa området. Vänligen försök igen.',
    leadNameTitle: 'Ledarnamn',
    leadcontactTitle: 'Ledarens telefonnummer',
    deputyLeadNameTitle: 'Ställföreträdande ledarnamn',
    deputyLeadcontactTitle: 'Ställföreträdande ledarens telefonnummer',
    leadNamePlaceholder: 'Ange ledarnamn',
    leadPhoneNumberPlaceHolder: 'Ange ledarens telefonnummer',
    deputyLeadNamePlaceHolder: 'Ange ställföreträdande ledarnamn',
    deputyLeadPhoneNumberPlaceHolder: 'Ange ställföreträdande ledarens telefonnummer',
    required_volunteer_count_title: 'Krävt volontärantal',
    accessColorLabel: 'Åtkomstfärg',
    require_walkie_talkie_label: 'Kräver walkie-talkie',
    shiftsVisibleLabel: 'Pass synliga för volontärer',
    shiftsVisibleDescription: 'När detta är aktiverat kommer godkända pass i detta område att vara synliga för volontärer för att acceptera/tacka nej. Pass måste också godkännas (låsas) för att vara synliga.',
}

export const UpdateAreaFormMeta: UpdateAreaFormMetaProps = {
    title: 'Redigera område',
    submitButton: 'Uppdatera område',
    submittingButton: 'Uppdaterar...'
}

export const DeleteAreaMeta: DeleteAreaMetaProps = {
    deleteButtonText: 'Ta bort område',
    confirmTitle: 'Ta bort område',
    confirmMessage: 'Är du säker på att du vill ta bort detta område? Denna åtgärd kan inte ångras och kommer att ta bort alla tillhörande pass och tilldelningar.'
}

export const ShiftFormModalMeta: ShiftFormModalMetaProps = {
    title: 'Skapa nytt pass',
    dutyLabel: 'Uppgiftstyp',
    dutyPlaceholder: 'Välj en uppgiftstyp',
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid',
    submitButton: 'Skapa pass',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa passet. Vänligen försök igen.',
    leadNameTitle: 'Ledarnamn',
    leadcontactTitle: 'Ledarens telefonnummer',
    deputyLeadNameTitle: 'Ställföreträdande ledarnamn',
    deputyLeadcontactTitle: 'Ställföreträdande ledarens telefonnummer',
    leadNamePlaceholder: 'Ange ledarnamn',
    leadPhoneNumberPlaceHolder: 'Ange ledarens telefonnummer',
    deputyLeadNamePlaceHolder: 'Ange ställföreträdande ledarnamn',
    deputyLeadPhoneNumberPlaceHolder: 'Ange ställföreträdande ledarens telefonnummer',
    required_volunteer_count_lable: 'Krävt volontärantal',
    accessColorLabel: 'Åtkomstfärg',
    require_walkie_talkie_label: 'Kräver walkie-talkie',
    criteriaLabel: 'Kriterier (Valfritt)',
    criteriaPlaceHolder: 'Ange detaljerade kriterier eller anteckningar...',
    titleLabel: 'Titel',
    titlePlaceHolder: 'Ange passtitel...',
    instructionLabel: 'Instruktioner (Valfritt)',
    instructionPlaceHolder: 'Ange dina instruktioner här...'
}

export const UpdateShiftFormMeta: UpdateShiftFormMetaProps = {
    title: 'Redigera pass',
    submitButton: 'Uppdatera pass',
    submittingButton: 'Uppdaterar...'
}

export const DuplicateShiftModalMeta: DuplicateShiftModalMetaProps = {
    title: 'Duplicera pass',
    description: 'Skapa kopior av detta pass. Du kan välja att inkludera eller exkludera volontärtilldelningar, och duplicera till samma område eller ett annat evenemang/område.',
    countLabel: 'Antal kopior',
    countPlaceholder: 'Ange antal (1-50)',
    countValidationError: 'Antalet måste vara mellan 1 och 50',
    includeAllocationsLabel: 'Inkludera volontärtilldelningar',
    includeAllocationsDescription: 'Om detta är markerat kommer alla aktuella volontärtilldelningar att kopieras till det/de nya passet/passen.',
    destinationLabel: 'Destination',
    sameAreaLabel: 'Samma område',
    differentAreaLabel: 'Annat evenemang/område',
    eventLabel: 'Evenemang',
    selectEventPlaceholder: 'Välj ett evenemang',
    areaLabel: 'Område',
    selectAreaPlaceholder: 'Välj ett område',
    selectAreaError: 'Vänligen välj ett område för de(t) duplicerade passet/passen',
    submitButton: 'Duplicera',
    submittingButton: 'Duplicerar...',
    cancelButton: 'Avbryt',
    errorMessage: 'Kunde inte duplicera passet. Vänligen försök igen.'
}

export const CopyShiftAllocationsModalMeta: CopyShiftAllocationsModalMetaProps = {
    title: 'Copy Shift Allocations',
    description: 'Copy the volunteers allocated to this shift into another shift. The destination shift times will be used and copied allocations will start as pending.',
    sourceShiftLabel: 'Source shift',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    shiftLabel: 'Shift',
    selectShiftPlaceholder: 'Select a shift',
    selectShiftError: 'Please select a destination shift',
    noTargetShiftsMessage: 'No other shifts available in this area',
    loadEventsError: 'Failed to load events',
    submitButton: 'Copy Allocations',
    submittingButton: 'Copying...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to copy shift allocations. Please try again.'
}

export const DuplicateAreaModalMeta: DuplicateAreaModalMetaProps = {
    title: 'Duplicera område',
    description: 'Skapa kopior av detta område och alla dess pass. Du kan välja att inkludera eller exkludera volontärtilldelningar, och duplicera till samma evenemang eller ett annat evenemang.',
    countLabel: 'Antal kopior',
    countPlaceholder: 'Ange antal (1-50)',
    countValidationError: 'Antalet måste vara mellan 1 och 50',
    includeAllocationsLabel: 'Inkludera volontärtilldelningar',
    includeAllocationsDescription: 'Om detta är markerat kommer alla aktuella passtilldelningar i detta område att kopieras till de(t) nya området/områdena.',
    destinationLabel: 'Destination',
    sameEventLabel: 'Samma evenemang',
    differentEventLabel: 'Annat evenemang',
    eventLabel: 'Evenemang',
    selectEventPlaceholder: 'Välj ett evenemang',
    selectEventError: 'Vänligen välj ett evenemang för de(t) duplicerade området/områdena',
    loadEventsError: 'Kunde inte läsa in evenemang',
    submitButton: 'Duplicera',
    submittingButton: 'Duplicerar...',
    cancelButton: 'Avbryt',
    errorMessage: 'Kunde inte duplicera området. Vänligen försök igen.'
}

export const DeleteShiftMeta: DeleteShiftMetaProps = {
    confirmTitle: 'Ta bort pass',
    confirmMessage: 'Är du säker på att du vill ta bort detta pass? Denna åtgärd kan inte ångras och kommer att ta bort alla tillhörande tilldelningar.'
}

export const TrainingListMeta: TrainingListMetaProps = {
    assignedTitle: 'Min tilldelade utbildning',
    availableTitle: 'Annan tillgänglig utbildning',
    errorTitle: 'Fel vid inläsning av utbildning',
    noAssignedTrainingsMessage: 'Du har ingen tilldelad utbildning för närvarande.',
    noAvailableTrainingsMessage: 'Ingen annan utbildning är tillgänglig.',
    loadingText: 'Laddar utbildning...',
    modulesLabel: 'moduler',
    durationLabel: 'Varaktighet',
    minutesSuffix: 'min',
    mandatoryBadge: 'OBLIGATORISK'
}

export const AdminTrainingsMeta: AdminTrainingsMetaProps = {
    title: 'Hantera utbildningar',
    description: 'Skapa, redigera och hantera utbildningsmoduler för volontärer',
    errorTitle: 'Fel vid inläsning av utbildningar',
    noTrainingsMessage: 'Inga utbildningar tillgängliga. Klicka på "Skapa ny utbildning" för att lägga till en.',
    loadingText: 'Laddar utbildningar...',
    assignVolunteersMessage: 'Tilldela volontärer'
}

export const TrainingFormModalMeta: TrainingFormModalMetaProps = {
    title: 'Skapa ny utbildning',
    nameLabel: 'Utbildningsnamn',
    namePlaceholder: 'Ange utbildningsnamn',
    descriptionLabel: 'Beskrivning',
    descriptionPlaceholder: 'Ange utbildningsbeskrivning',
    mandatoryLabel: 'Obligatorisk utbildning',
    policyLabel: 'Policy (visas endast på startsidan när den är ofullständig)',
    modulesLabel: 'Utbildningsmoduler',
    addModuleButton: 'Lägg till modul',
    removeModuleButton: 'Ta bort',
    moduleTypeLabel: 'Modultyp',
    moduleTitleLabel: 'Modultitel',
    moduleTitlePlaceholder: 'Ange modultitel',
    moduleUrlLabel: 'URL',
    moduleUrlPlaceholder: 'https://example.com/resurs',
    moduleFileLabel: 'Fil',
    moduleFilePlaceholder: 'Ingen fil vald',
    moduleFileUploadButton: 'Ladda upp fil',
    moduleFileUploadingButton: 'Laddar upp...',
    moduleFileRemoveButton: 'Ta bort fil',
    moduleContentTypeLabel: 'Innehållstyp',
    moduleContentTypeUrl: 'URL',
    moduleContentTypeFile: 'Filuppladdning',
    moduleContentTypeLibrary: 'Bibliotek',
    browseLibraryButton: 'Bläddra i bibliotek',
    libraryBrowserTitle: 'Välj video från bibliotek',
    libraryBrowserSelectButton: 'Välj video',
    libraryBrowserCancelButton: 'Avbryt',
    libraryBrowserLoadingText: 'Laddar videor...',
    libraryBrowserErrorText: 'Kunde inte ladda videor. Vänligen försök igen.',
    libraryBrowserNoVideosText: 'Inga videor i biblioteket ännu.',
    moduleDescriptionLabel: 'Beskrivning (Valfritt)',
    moduleDescriptionPlaceholder: 'Ange modulbeskrivning',
    moduleDurationLabel: 'Varaktighet (minuter)',
    moduleDurationPlaceholder: '15',
    moduleOrderPlaceholder: '0',
    moduleRequiredLabel: 'Krävs',
    noModulesMessage: 'Inga moduler tillagda ännu. Klicka på "Lägg till modul" för att skapa din första modul.',
    submitButton: 'Skapa utbildning',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa utbildningen. Vänligen försök igen.',
    questionsLabel: 'Utbildningsfrågor',
    addQuestionButton: 'Lägg till fråga',
    noQuestionMessage: 'Inga frågor tillagda ännu. Klicka på "Lägg till fråga" för att skapa din första fråga.',
    questionLable: 'Fråga',
    questionPlaceHolder: 'Ange fråga här',
    answerDescriptionLabel: 'Svarsbeskrivning (Valfritt)',
    answerDescriptionPlaceholder: 'Ge ytterligare sammanhang eller förklaring till denna fråga',
    optionLabel: 'Alternativ',
    addOptionButton: 'Lägg till alternativ',
    noOptionMessage: 'Inga alternativ tillagda ännu. Klicka på "Lägg till alternativ" för att skapa ditt första alternativ.',
    optionPlaceHolder: 'Ange alternativ här',
    optionsLabel: 'Alternativ',
    optionSelectionMessage: 'Vänligen välj alternativet som är svaret.',
    noOptionsDisplayMessage: 'Inga alternativ är tillgängliga för denna fråga.'
}

export const UpdateTrainingFormMeta: UpdateTrainingFormMetaProps = {
    title: 'Redigera utbildning',
    submitButton: 'Uppdatera utbildning',
    submittingButton: 'Uppdaterar...'
}

export const DocumentViewerMeta: DocumentViewerMetaProps = {
    loadingText: 'Laddar dokument...',
    errorTitle: 'Fel vid inläsning av dokument',
    errorInvalidUrl: 'Ogiltig dokument-URL angiven.',
    errorLoadingDocument: 'Kunde inte ladda dokumentet. Vänligen försök igen.'
}

export const VideoPlayerMeta: VideoPlayerMetaProps = {
    loadingText: 'Laddar video...',
    errorTitle: 'Fel vid inläsning av video',
    errorInvalidUrl: 'Ogiltig video-URL angiven.',
    errorLoadingVideo: 'Kunde inte ladda videon. Vänligen försök igen.',
    muteLabel: 'Ljud av',
    unmuteLabel: 'Ljud på',
    enterFullscreenLabel: 'Helskärm',
    exitFullscreenLabel: 'Avsluta helskärm',
    playbackSpeedLabel: 'Hastighet',
    captionsLabel: 'Undertexter'
}

export const UnsupportedModuleViewerMeta: UnsupportedModuleViewerMetaProps = {
    title: 'Modultypen stöds inte',
    message: 'Att visa {type}-moduler stöds inte för närvarande.',
    supportedTypes: 'Stöds för närvarande: Dokument (PDF), Video (YouTube, Vimeo, etc.)'
}

export const TrainingModulePageMeta: TrainingModulePageMetaProps = {
    backButtonLabel: 'Tillbaka till utbildningsdetaljer',
    moduleLabel: 'Modul {current} av {total}',
    previousModuleButton: 'Föregående modul',
    nextModuleButton: 'Nästa modul',
    errorTitle: 'Fel vid inläsning av modul',
    errorInvalidParameters: 'Ogiltiga utbildnings- eller modulparametrar.',
    errorTrainingNotFound: 'Utbildningen hittades inte.',
    errorModuleNotFound: 'Modulen hittades inte i denna utbildning.',
    errorInvalidContent: 'Ogiltigt format för utbildningsinnehåll.',
    errorFileNotFound: 'Dokumentfilen hittades inte.',
    errorNoDocumentSource: 'Ingen dokument-URL eller fil angiven för denna modul.',
    errorNoVideoSource: 'Ingen video-URL eller fil angiven för denna modul.',
    errorGeneric: 'Ett fel uppstod vid inläsning av modulen.',
    documentViewer: DocumentViewerMeta,
    videoViewer: VideoPlayerMeta,
    unsupportedViewer: UnsupportedModuleViewerMeta
}

export const TrainingModuleMeta: TrainingModuleMetaProps = {
    minutesSuffix: 'min'
}

export const VolunteerTrainingPageMeta: VolunteerTrainingPageMetaProps = {
    title: "Din tilldelade utbildning",
    description: "Få åtkomst till och slutför dina tilldelade utbildningsmoduler",
    errorTitle: "Fel",
    noTrainingMessage: "Ingen utbildning har tilldelats dig ännu.",
    viewButton: "Visa utbildning",
}

export const VolunteerPoliciesMeta: VolunteerPoliciesMetaProps = {
    title: "Policyer",
    description: "Granska och bekräfta nödvändiga policyer",
    errorTitle: "Fel",
    noPoliciesMessage: "Inga policyer har tilldelats dig ännu.",
    outstandingTitle: "Utestående policyer",
    acknowledgedTitle: "Bekräftade policyer",
    viewButton: "Visa policy",
}

export const VolunteerTrainingPageDetailsMeta: VolunteerTrainingPageDetailsMetaProps = {
    backToTrainingsButton: 'Tillbaka till utbildningar',
    loadingText: 'Laddar utbildning',
    errorTitle: 'Fel uppstod vid inläsning av utbildningsdetaljer.',
    modulesLabel: 'Moduler',
    totalDurationLabel: 'Total varaktighet',
    minutesSuffix: 'min',
    mandatoryBadge: 'Obligatorisk',
    completedBadge: 'Slutförd',
    inProgressBadge: 'Pågår',
    moduleNumberPrefix: 'Modul',
    completeTrainingButton: 'Markera som slutförd',
    trainingCompletedMessage: 'Denna utbildning har slutförts framgångsrikt.',
}

export const ModuleCompletionModalMeta: CompletionQuestionsModalMetaProps = {
    title: "Modulfrågor",
    submitButton: "Skicka in svar",
    submittingButton: "Slutför modul",
    cancelButton: "Avbryt"
}

export const ProfileMeta: VolunteerProfileMetaProps = {
    loadingText: 'Laddar...',
    errorTitle: 'Fel',
    backToVolunteersButton: 'Tillbaka till volontärer',
    editProfileButton: 'Redigera profil',
    completeProfileButton: 'Slutför profil',
    noAreasMessage: '',
    csid: 'Volontär-ID',
    first_name: 'Förnamn',
    last_name: 'Efternamn',
    second_last_name: 'Andra efternamn',
    gender: 'Kön',
    dob: 'Födelsedatum',
    age: 'Ålder',
    email: 'E-post',
    phone: 'Telefon',
    country_code: 'Landskod',
    country: 'Land',
    country_of_birth: 'Födelseland',
    jamat_khana: 'Jamatkhana',
    service_location: 'Tjänstgöringsplats',
    service_record: 'IV-position',
    family_origin: 'Familjens ursprung',
    languages: 'Språk',
    support_needs: 'Särskilda stödbehov',
    multi_faith_family: 'Flerreligiös familj',
    ismaili: 'Ismaili',
    registered_volunteer_label: 'Registrerad volontär',
    eligible_for_duty_label: 'Kvalificerad för uppgift',
    yes: 'Ja',
    no: 'Nej',
    personalInfoSection: 'Personuppgifter',
    locationSection: 'Platsinformation',
    additionalInfoSection: 'Volontärinformation',
    preferencesSection: 'Preferenser',
    flagsSection: 'Ytterligare information',
    trainingsSection: 'Tilldelade utbildningar',
    deleteTrainingMessage: 'Är du säker? Denna utbildning kommer att tas bort från volontären och de kommer att förlora alla relaterade framsteg.',
    deleteTrainingTitle: 'Ta bort utbildning',
    languageSection: 'Språk',
    volunteer_for_visit_label: 'Vill vara volontär för Didar?',
    availability_label: 'Tillgänglighet',
    uploadedDocumentsLabel: "Uppladdade dokument",
    allocatedShiftsLabel: "Tilldelningar",
    eventLeadLabel: "Evenemangsledare",
    areaLeadLabel: "Områdesledare",
    shiftLeadLabel: "Passledare",
    otherAllocationLabel: "Andra",
    negativeListLabel: "Kan inte utföra arbetsuppgifter"
}

export const VolunteerTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        { key: "email", header: "E-post" },
        { key: "phone", header: "Telefonnummer" },
        { key: "gender", header: "Kön" },
        //{ key: "dob", header: "DOB" },
        { key: "age", header: "Ålder" },
        { key: "country_of_birth", header: "Födelseland" },
        { key: "family_origin", header: "Familjens ursprung" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "service_record", header: "IV-position" },
        { key: "ismaili", header: "Ismaili" },
        { key: "multi_faith_family", header: "Flerreligiös familj" },
        { key: "eligible_for_duty", header: "Kvalificerad för uppgift" },
        { key: "languages", header: "Språk" },
        { key: "preferences", header: "Preferenser" },
        { key: "flags", header: "Ytterligare färdigheter" },
        //{ key: "support_needs", header: "Special Support" },
    ],
};


export const VolunteerTrainingTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        { key: "gender", header: "Kön" },
        //{ key: "dob", header: "DOB" },
        // { key: "age", header: "Age" },
        { key: "service_record", header: "IV-position" },
        { key: "preferences", header: "Preferenser" },
        { key: "flags", header: "Ytterligare färdigheter" },
    ],
};

export const VolunteerAllocationTableMeta = {
    columns: [
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        // { key: "gender", header: "Gender" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familjens ursprung" },
        { key: "service_record", header: "IV-position" },
        { key: "flags", header: "Ytterligare färdigheter" },
    ],
};

export const ConflictInformationTableMeta = {
    columns: [
        { key: "event_name", header: "Evenemang" },
        { key: "area_name", header: "Område" },
        { key: "shift_title", header: "Pass" },
        { key: "shift_duty_name", header: "Uppgift" },
        { key: "start_time", header: "Pass start" },
        { key: "end_time", header: "Pass slut" },
        { key: "type", header: "Anledning" },
        { key: "action", header: "Åtgärder" },
    ],
};

export const VolunteerAllocationViewTableMeta = {
    columns: [
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        { key: "phone", header: "Telefonnummer" },
        { key: "age_band", header: "Åldersgrupp" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familjens ursprung" },
        { key: "service_record", header: "IV-position" },
        { key: "flags", header: "Ytterligare färdigheter" },
        { key: "support_needs", header: "Stödbehov" },
        { key: "action", header: "Åtgärder" },
    ],
};

export const VolunteerEventShiftViewTableMeta = {
    columns: [
        { key: "event_name", header: "Evenemang" },
        { key: "area_name", header: "Område" },
        { key: "shift_duty_name", header: "Pass" },
        { key: "start_time", header: "Pass start" },
        { key: "end_time", header: "Pass slut" },
        { key: "status", header: "Status" },
        { key: "action", header: "Åtgärd" }
    ],
};

export const VolunteerAreaShiftViewTableMeta = {
    columns: [
        { key: "shift_duty_name", header: "Pass" },
        { key: "start_time", header: "Pass start" },
        { key: "end_time", header: "Pass slut" },
        { key: "status", header: "Status" },
        { key: "action", header: "Åtgärd" }
    ],
};


export const LeadAssginmentViewTableMeta = {
    columns: [
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        { key: "email", header: "E-post" },
        { key: "phone", header: "Telefonnummer" },
        { key: "flags", header: "Ytterligare färdigheter" },
    ],
};

export const MIVolunteerViewMeta = {
    columns: [
        { key: "first_name", header: "Förnamn" },
        { key: "last_name", header: "Efternamn" },
        { key: "email", header: "E-post" },
        { key: "phone", header: "Telefonnummer" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familjens ursprung" },
        { key: "service_record", header: "IV-position" },
        { key: "uk_didar_registration_ack", header: "Didar-bekräftelse" }

    ],
};



export const AssignTrainingFormModalMeta: AssignTrainingFormModalMetaProps = {
    title: "Tilldela utbildningar till volontär",
    submitButton: "Tilldela",
    submittingButton: "Tilldelar",
    cancelButton: "Avbryt",
    trainingLabel: "Tillgängliga utbildningar",
    trainingPlaceHolder: "Välj utbildning",
    addTrainingButton: "Lägg till utbildning",
    noTrainingMessage: 'Inga utbildningar tillagda ännu. Klicka på "Lägg till utbildning" för att lägga till din första utbildning.',
    noTrainingSelectedMessage: 'Lägg till minst en utbildning för att tilldela.'
}

export const AnnouncementMeta: AnnouncementMetaProps = {
    title: 'Meddelanden',
    description: 'Hantera alla dina meddelanden till volontärerna.',
    createButton: 'Publicera nytt',
    submitButton: 'Publicera',
    submittingButton: 'Publicerar...',
    errorTitle: 'Misslyckades att hämta meddelanden',
    noAnnouncementsMessage: 'Inga meddelanden har publicerats ännu.',
    announcementSearchPlaceHolder: 'Sök meddelande efter titel...',
    backButton: 'Tillbaka till Admin Hub',
    onDeleteTitle: 'Ta bort meddelande',
    onDeleteMessage: 'Om du tar bort detta meddelande tas det bort permanent för alla användare. Denna åtgärd kan inte ångras.'
}

export const AnnouncementsFormModalMeta: AnnouncementFormModalMetaProps = {
    errorMessage: 'Fel uppstod vid publicering av formulär',
    createTitle: 'Publicera nytt meddelande',
    editTitle: 'Meddelandedetaljer',
    cancelButton: 'Avbryt',
    submitButton: 'Publicera',
    submittingButton: 'Publicerar...',
    titleLabel: 'Titel',
    titlePlaceHolder: 'Ange meddelandetitel...',
    contentLabel: 'Innehåll',
    contentPlaceHolder: 'Ange meddelandeinnehåll...',
    prioritiyMessage: 'Markera som prioritet'
}

export const AnnouncementViewModalMeta: AnnouncementViewModalMetaProps = {
    viewTitle: 'Meddelande',
    titleLabel: 'Titel',
    contentLabel: 'Innehåll',
    prioritiyMessage: 'Detta är ett prioritetsmeddelande.',
    cancelButton: 'Stäng'
}

export const BulkTrainingAssignmentFormMeta: BulkTrainingAssignmentFormMetaProps = {
    title: 'Tilldela ',
    cancelButton: 'Avbryt',
    submitButton: 'Tilldela utbildning',
    submittingButton: 'Tilldelar...',
    previewButton: 'Förhandsgranska',
    previewingButton: 'Laddar...',
    // Assignment mode selection
    assignmentModeLabel: 'Tilldelningsmetod',
    modeAllVolunteers: 'Alla registrerade volontärer',
    modeAllVolunteersDescription: 'Tilldela till alla godkända volontärer i systemet',
    modeByEvent: 'Per evenemang',
    modeByEventDescription: 'Tilldela till volontärer tilldelade till specifika evenemang',
    modeByArea: 'Per område',
    modeByAreaDescription: 'Tilldela till volontärer tilldelade till specifika områden',
    modeByShift: 'Per pass',
    modeByShiftDescription: 'Tilldela till volontärer tilldelade till specifika pass',
    modeByDuty: 'Per uppgiftstyp',
    modeByDutyDescription: 'Tilldela till volontärer tilldelade till pass med specifika uppgiftstyper',
    modeManual: 'Manuellt val',
    modeManualDescription: 'Filtrera och välj individuella volontärer manuellt',
    // Selection labels
    selectEventsLabel: 'Välj evenemang',
    selectAreasLabel: 'Välj områden',
    selectShiftsLabel: 'Välj pass',
    selectDutiesLabel: 'Välj uppgiftstyper',
    // Lead inclusion options
    includeLeadsLabel: 'Inkludera ledare',
    includeEventLeadsLabel: 'Inkludera evenemangsledare',
    includeAreaLeadsLabel: 'Inkludera områdesledare',
    includeShiftLeadsLabel: 'Inkludera passledare',
    // Preview results
    previewResultsTitle: 'Förhandsgranska',
    totalVolunteersLabel: 'Totalt antal volontärer som matchar kriterierna',
    alreadyAssignedLabel: 'Har redan denna utbildning',
    willBeAssignedLabel: 'Kommer att tilldelas',
    // Messages
    noSelectionMessage: 'Vänligen välj minst ett objekt',
    selectEventFirst: 'Välj ett evenemang först för att se områden',
    selectAreaFirst: 'Välj ett område först för att se pass'
}

export const ShiftAssignmentFormMeta: ShiftAssignmentFormMetaProps = {
    title: 'Tilldela volontärer',
    cancelButton: 'Avbryt',
    submitAllocateButton: 'Tilldela',
    submittingAllocateButton: 'Tilldelar...',
    submitRemoveButton: 'Ta bort',
    submittingRemoveButton: 'Tar bort...',
    conflictTitle: 'Krockande pass',
    conflictMessage: 'Följande pass krockar med denna tilldelning.',
    futureConflictMessage: 'Följande pass kommer att krocka med denna tilldelning.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Dubbletter för ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Passtilldelningar (${count})`,
    excludedAllocationsTitle: (count: number) => `Exkluderad från dubbletträkning (${count})`,
    excludedAllocationsDescription: 'Dessa tilldelningar är från evenemang som inte inkluderas i dubblettkontroller.',
    coreTeamAssignmentsTitle: (count: number) => `Kärnteamstilldelningar (${count})`,
    leadPositionsTitle: (count: number) => `Ledar-/Ställföreträdande ledarpositioner (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Exkluderade ledarpositioner (${count})`,
    excludedLeadPositionsDescription: 'Dessa ledarpositioner är från evenemang som inte inkluderas i dubblettkontroller.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Evenemang',
    areaColumn: 'Område',
    shiftColumn: 'Pass',
    actionsColumn: 'Åtgärder',
    dateTimeColumn: 'Datum/Tid',
    noDuplicationsMessage: 'Inga andra tilldelningar eller kärnteamstilldelningar hittades.',
    closeModalButton: 'Stäng',
    submittedStatus: 'Inskickad',
    approvedStatus: 'Godkänd',
    pendingStatus: 'Väntande',
    acceptedStatus: 'Accepterad',
    declinedStatus: 'Tackat nej',
    roleColumn: 'Roll',
    streamsColumn: 'Strömmar',
    publishShiftTitle: 'Skicka pass för godkännande?',
    publishShiftMessage: 'När detta pass har skickats in kan inga ytterligare tilldelningar göras eller tas bort.',
    publishButton: 'Skicka för godkännande',
    lockButton: 'Lås',
    unlockButton: 'Lås upp'
}

export const AllLanguages = [
    "Arabic",
    "Persian / Farsi",
    "Bengali",
    "English",
    "Gujarati / Kutchi",
    "Urdu / Hindi",
    "Punjabi / Sindhi",
    "French",
    "German",
    "Mandarin Chinese / Japanese",
    "Portuguese",
    "Russian",
    "Spanish",
    "Swahili",
    "Turkish",
    "Tajik",

    "Danish",
    "Swedish",
    "Norwegian",
    "Finish",
    "Dutch",
    "Polish",
    "Italian",
]

export const IVPositions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer"
]

export const IVPositionFilterOptions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer",
    "Volunteer",
    "Junior Volunteer",
    "Team Leader",
    "JV Team Leader",
    "Deputy JV Team Leader",
    "Director",
    "Deputy Director",
    "IV Executive",
    "IV Events",
    "Other"
]

export const GenderOptions = [
    "Male",
    "Female",
    "Prefer Not to Say"
]

export const UserMetaProps = {
    title: 'Användarhantering',
    description: 'Hantera användare och roller med åtkomstkontroll',
    errorTitle: 'Fel vid inläsning av användare',
}
export const UserFormModalMeta: UserFormModalMetaProps = {
    title: 'Skapa ny användare',
    nameLabel: 'Fullständigt namn',
    namePlaceholder: 'Ange fullständigt namn',
    emailLabel: 'E-post',
    emailPlaceholder: 'Ange e-postadress',
    roleLabel: 'Roll',
    rolePlaceholder: 'Välj roll',
    submitButton: 'Skapa användare',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa användare. Vänligen försök igen.',
    usernameLabel: 'Användarnamn',
    usernamePlaceholder: 'Användarnamn',
}

export const UpdateUserFormMeta: UpdateUserFormMetaProps = {
    title: 'Redigera användare',
    submitButton: 'Uppdatera användare',
    submittingButton: 'Uppdaterar...'
}
export const DeleteUserMeta: DeleteUserMetaProps = {
    deleteButtonText: 'Ta bort användare',
    confirmTitle: 'Ta bort användare',
    confirmMessage: 'Är du säker på att du vill ta bort denna användare? Denna åtgärd kan inte ångras och kommer att ta bort den valda användaren.'
}
export const DEFAULT_FILTERS: VolunteerFiltersWithConflictProps = {
    name: "",
    email: "",
    phone_number: "",
    id: "",
    country: "eu",
    age: null,
    country_of_birth: "",
    family_origin: "",
    jamat_khana: "",
    iv_position: "",
    ismaili: null,
    registered_volunteer: null,
    profile_submitted: true,
    approved_volunteer: null,
    eligible_for_duty: true,
    multi_faith_family: null,
    has_support_needs: null,
    tags: [],
    preferences: [],
    languages: [],
    service_record: [],
    genders: [],
    trainings: [],
    training_filter_type: 'at_least_one',
    age_start: 18,
    age_end: null,
    conflict: null,
    status: null,
    volunteer_for_visit: 1,
    iiuk_registeration: "any", // "iiuk"
    availability: [],
    availability_filter_type: 'at_least_one',
    event_assignment_type: null,
    event_assignment_events: [],
    documents: [],
    allocation_status: [],
    core_team_assignment_type: null,
    clusters: []
};

export const LeadAssignModalMeta: LeadAssignModalPropsMeta = {
    cancelButton: "Avbryt",
    selectButton: "Välj",
    nameSearchPlaceholder: 'Sök på namn...',
    emailSearchPlaceholder: 'Sök på e-post...',
    phoneSearchPlaceholder: 'Sök på telefon...',
    idSearchPlaceholder: 'Sök på ID...',
    searchButton: 'Sök',
    clearButton: 'Rensa',
    showingLabel: 'Visar',
    volunteersLabel: 'volontärer',
    noResultsMessage: 'Inga volontärer hittades som matchar din sökning',
    noVolunteersMessage: 'Inga volontärer tillgängliga',
    idColumn: 'ID',
    nameColumn: 'Namn',
    phoneColumn: 'Telefon',
    emailColumn: 'E-post',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Dubbletter',
    viewDuplicationsButton: (count: number) => `Visa (${count})`,
    actionColumn: 'Åtgärd',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Dubbletter för ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Passtilldelningar (${count})`,
    excludedAllocationsTitle: (count: number) => `Exkluderad från dubbletträkning (${count})`,
    excludedAllocationsDescription: 'Dessa tilldelningar är från evenemang som inte inkluderas i dubblettkontroller.',
    coreTeamAssignmentsTitle: (count: number) => `Kärnteamstilldelningar (${count})`,
    leadPositionsTitle: (count: number) => `Ledar-/Ställföreträdande ledarpositioner (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Exkluderade ledarpositioner (${count})`,
    excludedLeadPositionsDescription: 'Dessa ledarpositioner är från evenemang som inte inkluderas i dubblettkontroller.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Evenemang',
    areaColumn: 'Område',
    shiftColumn: 'Pass',
    dateTimeColumn: 'Datum/Tid',
    noDuplicationsMessage: 'Inga andra tilldelningar eller kärnteamstilldelningar hittades.',
    closeModalButton: 'Stäng',
    submittedStatus: 'Inskickad',
    approvedStatus: 'Godkänd',
    pendingStatus: 'Väntande',
    acceptedStatus: 'Accepterad',
    declinedStatus: 'Tackat nej',
    roleColumn: 'Roll',
    streamsColumn: 'Strömmar'
}

export const AccessColorMeta: AccessColorMetaProps = {
    title: 'Åtkomstfärger',
    description: 'Hantera alla åtkomstfärger.',
    createButton: 'Skapa ny',
    submitButton: 'Skapa',
    submittingButton: 'Skapar...',
    errorTitle: 'Misslyckades att hämta åtkomstfärger',
    noAnnouncementsMessage: 'Inga åtkomstfärger har skapats ännu.',
    backButton: 'Tillbaka till Admin Hub',
    onDeleteTitle: 'Ta bort åtkomstfärg',
    onDeleteMessage: 'Om du tar bort denna åtkomst tas den bort permanent för alla användare. Denna åtgärd kan inte ångras.'
}

export const AccessColorFormModalMeta: AccessColorFormModalMetaProps = {
    title: 'Skapa ny åtkomstfärg',
    submitButton: 'Skapa färg',
    submittingButton: 'Skapar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    errorMessage: 'Kunde inte skapa åtkomstfärg. Vänligen försök igen.',
    colorLabel: 'Vald färg',
    presetColorLabel: "Förinställda färger",
    updateButton: 'Uppdatera färg',
    updatingButton: 'Uppdaterar färg'

}

export const COLOR_PRESETS = [
    '#EF4444', // red
    '#F97316', // orange
    '#FACC15', // yellow
    '#22C55E', // green
    '#3B82F6', // blue
    '#6366F1', // indigo
    '#8B5CF6', // purple
    '#EC4899', // pink
    '#6B7280', // gray
];

export const AVAILABILITY_OPTIONS = [
    "Setup Support (3rd July)",
    "Pre Didar (4th July)",
    "Didar Day (5th July)",
    "Post Didar (6th July)"
] as const


export const VOLUNTEER_FOR_VISIT_MAP = {
    1: "Ja, jag vill vara volontär",
    0: "Nej, inte tillgänglig för närvarande",
    null: "Inget val" // default case
} as const

export const VOLUNTEER_FOR_VISIT_MAP_INVERSE = {
    "Ja, jag vill vara volontär": 1,
    "Nej, inte tillgänglig för närvarande": 0,
    "Ospecificerat": "null",
} as const

export const TrainingSequenceEditMeta: TrainingSequenceEditMetaProps = {
    title: 'Redigera utbildningssekvens',
    message: 'Dra utbildningar för att ändra deras sekvens.',
    cancelButton: 'Avbryt',
    submitButton: 'Uppdatera',
    submittingButton: 'Uppdaterar...'
}

export const VolunteerOverviewMeta: VolunteerOverviewMetaProps = {
    title: 'Volontärsammanfattning',
    description: 'Översikt över volontärers demografi',
    errorTitle: 'Fel vid hämtning av volontärinformation',
    loadingText: 'Laddar'
}

export const TrainingsOverviewMeta: TrainingsOverviewMetaProps = {
    title: 'Utbildningsöversikt',
    description: 'Översikt över utbildningstilldelningar',
    loadingText: 'Laddar...',
    errorTitle: 'Fel vid inläsning av utbildningsdata'
}

export const AllocationsOverviewMeta: AllocationsOverviewMetaProps = {
    title: 'Tilldelningssammanfattning',
    description: 'Översikt över tilldelningars demografi',
    eventsCardTitle: 'Totalt antal evenemang',
    areaCardTitle: 'Totalt antal områden',
    shiftCardTitle: 'Totalt antal pass',
    volunteersCardTitle: 'Totalt antal volontärer',
    allocationsCardTitle: 'Totalt antal tilldelningar',
    allocationStatusTitle: 'Tilldelningsstatus',
    pendingLabel: 'Väntande',
    acceptedLabel: 'Accepterad',
    declinedLabel: 'Tackat nej',
    loadingText: 'Laddar instrumentpanel...',
    errorTitle: 'Fel vid inläsning av instrumentpanel'
}

export const CoreStreamOverviewMeta: CoreStreamOverviewMetaProps = {
    title: 'Översikt över kärnteamströmmar',
    description: 'Översikt över tilldelningar i kärnteamets strömmar',
    loadingText: 'Laddar...',
    errorTitle: 'Fel vid inläsning av kärnteamdata',
    noDataMessage: 'Ingen kärnteamdata tillgänglig.'
}

export const VolunteerStatsTableOverviewMeta: VolunteerStatsTableOverviewMetaProps = {
    title: 'Volontärstatistik',
    description: 'Översikt över volontärers demografiska statistik',
    loadingText: 'Laddar...',
    errorTitle: 'Fel vid inläsning av statistikdata.',
    noDataMessage: 'Ingen statistikdata tillgänglig.'
}

export const DidarAcknowledgementOverviewMeta: DidarAcknowledgementOverviewMetaProps = {
    title: 'Översikt över Didar-bekräftelser',
    description: 'Översikt över didar-bekräftelser',
    loadingText: 'Laddar...',
    errorTitle: 'Fel vid inläsning av bekräftelsedata.',
    noDataMessage: 'Ingen bekräftelsedata tillgänglig.'
}


export const DashboardMeta: DashboardMetaProps = {
    title: 'Instrumentpanel',
    description: 'Översikt över användare, volontärer och tilldelningar',
    eventsCardTitle: 'Totalt antal evenemang',
    areaCardTitle: 'Totalt antal områden',
    shiftCardTitle: 'Totalt antal pass',
    volunteersCardTitle: 'Totalt antal volontärer',
    allocationsCardTitle: 'Totalt antal tilldelningar',
    allocationStatusTitle: 'Tilldelningsstatus',
    pendingLabel: 'Väntande',
    acceptedLabel: 'Accepterad',
    declinedLabel: 'Tackat nej',
    loadingText: 'Laddar instrumentpanel...',
    errorTitle: 'Fel vid inläsning av instrumentpanel'
}


export const MangementAnalyticsMeta: ManagementAnalyticsMetaProps = {
    title: 'Statistik',
    description: 'Vyer & Filter',
    errorTitle: 'Fel vid hämtning av datainformation',
    loadingText: 'Laddar...'
}

export const CHART_COLORS = [
    "#2563eb", // blue
    "#16a34a", // green
    "#f59e0b", // amber
    "#dc2626", // red
    "#7c3aed", // violet
    "#0891b2", // cyan
    "#9333ea", // purple
    "#65a30d", // lime
    "#0f766e", // teal
    "#be123c", // rose
    "#ea580c", // orange
    "#1d4ed8", // indigo
    "#15803d", // dark green
    "#854d0e", // brown/gold
    "#9f1239", // dark rose
    "#0369a1", // sky blue
    "#4d7c0f", // olive
    "#6b21a8", // deep purple
    "#b91c1c", // dark red
    "#0f172a", // slate (near-black)
];




export const CHART_HEIGHT_MAP: Record<MaxChartSize, number> = {
    sm: 220,
    md: 260,
    lg: 300,
    xl: 340,
    '2xl': 380,
    '3xl': 420,
    '4xl': 460,
    '5xl': 520,
    '6xl': 580,
    '7xl': 640,
    '8xl': 720,
    '9xl': 800,
    '10xl': 880,
};

export const CHART_WIDTH_CLASSES: Record<MaxChartSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl',
    '9xl': 'max-w-9xl',
    '10xl': 'max-w-10xl',
};

export const ANALYTICS_TABS: { key: AnalyticsTab; label: string }[] = [
    { key: "dashboard", label: "Instrumentpanel" },
    { key: "trainings", label: "Utbildningsöversikt" },
    { key: "volunteers", label: "Volontärdemografi" },
    { key: "volunteertable", label: "Volontärstatistik" },
    { key: "didar", label: "Didar-bekräftelser" },
    { key: "iff", label: "Flerreligiösa familjers demografi" },
    { key: "non-iiuk", label: "Icke-IIUK volontärdemografi" },
    { key: 'duty_acceptance', label: "Uppgiftsacceptansstatistik" },
    { key: 'check-in', label: 'Incheckningsdemografi' },
];

export const InternationalRegisterationsMeta: InternationalRegisterationsMetaProps = {
    title: "Internationella registreringar",
    description: "Följande internationella registreringar har tagits emot.",
    errorTitle: "Fel uppstod vid hämtning av internationella registreringar.",
    noDataMessage: "Inga registreringar tillgängliga.",
    loadingText: "Laddar registreringsförfrågan",
    exportButton: "Exportera till CSV",
    lastSignInColumn: "Senaste inloggning",
    neverSignedInText: "Aldrig inloggad",
}

export const ShiftStatusMap = {
    0: 'Öppen',
    1: 'Under granskning',
    2: 'Godkänd',
    3: 'Avvisad'
}

export const EmailCampaignsMeta: EmailCampaignsMetaProps = {
    title: 'E-postkampanjer',
    description: 'Skapa och hantera e-postutskick till volontärer',
    createButton: 'Skapa kampanj',
    subjectLabel: 'Ämne',
    statusLabel: 'Status',
    recipientsLabel: 'Mottagare',
    progressLabel: 'Framsteg',
    createdLabel: 'Skapad',
    actionsLabel: 'Åtgärder',
    editButton: 'Redigera',
    deleteButton: 'Ta bort',
    viewButton: 'Visa',
    statusDraft: 'Utkast',
    statusTestSent: 'Test skickat',
    statusPendingApproval: 'Väntar på godkännande',
    statusSending: 'Skickar',
    statusCompleted: 'Slutförd',
    statusFailed: 'Misslyckad',
    pendingApprovalCountLabel: (count) => `${count} väntar på godkännande`,
    showPendingApprovalOnlyLabel: 'Visa endast väntande godkännande',
    showAllCampaignsLabel: 'Visa alla kampanjer',
    noPendingApprovalCampaignsMessage: 'Inga kampanjer väntar för närvarande på godkännande.',
    noCampaignsMessage: 'Inga e-postkampanjer hittades. Skapa din första kampanj för att komma igång.',
    loadingText: 'Laddar kampanjer...',
    errorTitle: 'Fel vid inläsning av kampanjer',
    deleteConfirmTitle: 'Ta bort kampanj',
    deleteConfirmMessage: 'Är du säker på att du vill ta bort denna kampanj? Denna åtgärd kan inte ångras.',
    cancelButton: 'Avbryt',
    confirmDeleteButton: 'Ta bort kampanj',
    exportRecipientsButton: 'Exportera mottagare'
}

export const EmailCampaignFormMeta: EmailCampaignFormMetaProps = {
    createTitle: 'Skapa e-postkampanj',
    editTitle: 'Redigera e-postkampanj',
    subjectLabel: 'E-postämne',
    subjectPlaceholder: 'Ange e-postämne...',
    bodyLabel: 'E-postinnehåll',
    bodyPlaceholder: 'Skriv ditt e-postmeddelande...',
    saveDraftButton: 'Spara utkast',
    cancelButton: 'Avbryt',
    previewButton: 'Förhandsgranska',
    sendTestButton: 'Skicka test',
    sendCampaignButton: 'Skicka kampanj',
    submitForApprovalButton: 'Skicka för godkännande',
    approveCampaignButton: 'Godkänn och skicka',
    denyCampaignButton: 'Neka och öppna igen',
    testEmailsLabel: 'Test-e-postadresser',
    testEmailsPlaceholder: 'epost@exempel.com',
    testEmailsHint: 'Ange upp till 10 e-postadresser för att skicka testmeddelanden',
    addEmailButton: 'Lägg till e-post',
    removeEmailButton: 'Ta bort',
    confirmSendTitle: 'Skicka e-postkampanj',
    confirmSendMessage: (count) => `Du är på väg att skicka detta e-postmeddelande till ${count} mottagare. Denna åtgärd kan inte ångras. Är du säker?`,
    confirmSubmitTitle: 'Skicka kampanj för godkännande',
    confirmSubmitMessage: (count) => `Skicka denna kampanj för godkännande med ${count} mottagare som kan få e-post? Innehåll och mottagare låses.`,
    confirmApproveTitle: 'Godkänn och skicka kampanj',
    confirmApproveMessage: (count) => `Godkänn denna kampanj och börja skicka den till ${count} mottagare? Denna åtgärd kan inte ångras.`,
    confirmDenyTitle: 'Neka kampanj',
    confirmDenyMessage: 'Neka denna kampanj och öppna den för redigering igen? Skaparen kan uppdatera innehåll och mottagare innan den skickas in igen.',
    confirmDenyButton: 'Neka kampanj',
    noTestSentWarning: 'Varning: Du har inte skickat några testmeddelanden ännu. Det rekommenderas att skicka testmeddelanden innan du skickar till alla volontärer.',
    confirmButton: 'Bekräfta skicka',
    errorSaving: 'Kunde inte spara kampanj',
    errorLoading: 'Kunde inte ladda kampanj',
    successSaved: 'Kampanjen har sparats',
    successTestSent: 'Testmeddelande(n) skickades',
    successSent: 'Kampanjen skickas',
    successSubmitted: 'Kampanjen har skickats för godkännande',
    successDenied: 'Kampanjen nekades och öppnades för redigering igen',
    contentLockedPendingApproval: 'Denna kampanj har skickats för godkännande. Innehåll och mottagare är låsta tills en godkännare börjar skicka den.',
    // Targeting criteria
    targetingTitle: 'Lägg till mottagare efter grupp',
    targetingDescription: 'Välj en målgruppsmetod för att lägga till en grupp mottagare',
    allVolunteersLabel: 'Alla volontärer med inskickade profiler',
    targetEventLabel: 'Filtrera efter evenemang (valfritt)',
    targetAreaLabel: 'Filtrera efter område (valfritt)',
    targetShiftLabel: 'Filtrera efter pass (valfritt)',
    targetDutyLabel: 'Filtrera efter uppgiftstyp (valfritt)',
    selectEventPlaceholder: 'Alla evenemang (alla volontärer)',
    selectAreaPlaceholder: 'Alla områden i detta evenemang',
    selectShiftPlaceholder: 'Alla pass i detta område',
    selectDutyPlaceholder: 'Alla uppgiftstyper',
    loadingEvents: 'Laddar evenemang...',
    loadingAreas: 'Laddar områden...',
    loadingShifts: 'Laddar pass...',
    loadingDuties: 'Laddar uppgifter...',
    includeLeadsLabel: 'Inkludera även ledare:',
    includeEventLeadsLabel: 'Evenemangsledare',
    includeAreaLeadsLabel: 'Områdesledare/ställföreträdare',
    includeShiftLeadsLabel: 'Passledare/ställföreträdare',
    // Volunteer types and volunteer filters for "all volunteers" option
    volunteerTypesLabel: 'Volontärtyper',
    volunteerTypeIiukUkIreland: 'IIUK-registrerad (Lokal - Europa)',
    volunteerTypeIiukEurope: 'IIUK-registrerad (International)',
    volunteerTypeNonIiuk: 'Volontärcommunity (icke-IIUK)',
    volunteerForVisitLabel: 'Volontärarbetar under Didar',
    volunteerForVisitYes: 'Volontärarbetar under Didar (har angett tillgänglighet)',
    volunteerForVisitNo: 'Nej - inte tillgänglig att volontärarbeta',
    volunteerForVisitBoth: 'Båda (alla svar)',
    // Recipient management
    recipientManagementTitle: 'Hantera mottagare',
    recipientManagementDescription: 'Lägg till mottagare individuellt eller i grupp. Dubbletter tas bort automatiskt.',
    recipientSourceHistoryTitle: 'Mottagarkällhistorik',
    recipientSourceHistoryDescription: 'Granska hur mottagare lades till innan du godkänner denna kampanj.',
    recipientSourceNoHistory: 'Ingen källhistorik har registrerats för denna kampanj. Den kan ha skapats innan spårning lades till.',
    recipientSourceAddedLabel: 'Tillagda',
    recipientSourceSelectedLabel: 'Valda',
    recipientSourceDuplicatesLabel: 'Dubbletter hoppades över',
    recipientSourceWithoutEmailLabel: 'Saknar e-post',
    recipientSourceTotalAfterLabel: 'Totalt efter ändring',
    recipientSourceAddedByLabel: 'Av',
    recipientSourceShowButton: 'Visa historik',
    recipientSourceHideButton: 'Dölj historik',
    recipientListTitle: 'Mottagarlista',
    noRecipientsMessage: 'Inga mottagare tillagda ännu. Använd knapparna ovan för att lägga till mottagare.',
    addGroupButton: 'Lägg till grupp',
    addIndividualButton: 'Lägg till individuell',
    clearAllButton: 'Rensa alla',
    recipientCountLabel: (count) => `${count} mottagare`,
    removeRecipientButton: 'Ta bort',
    searchVolunteersPlaceholder: 'Sök volontärer på namn...',
    addSelectedButton: 'Lägg till valda',
    groupAddedMessage: (added, total) => `Lade till ${added} ny(a) mottagare. Totalt: ${total}`,
    individualAddedMessage: (added, total) => `Lade till ${added} mottagare. Totalt: ${total}`,
    clearConfirmTitle: 'Rensa alla mottagare',
    clearConfirmMessage: 'Är du säker på att du vill ta bort alla mottagare från denna kampanj?',
    confirmClearButton: 'Rensa alla',
    // Email suggestions
    emailSuggestionsTitle: 'Ange e-postadress',
    emailSuggestionsDescription: 'Välj en e-postadress för',
    customEmailLabel: 'Ange anpassad e-post',
    saveButton: 'Spara',
    noEmailSuggestions: 'Inga förslag tillgängliga. Vänligen ange en e-postadress manuellt.',
    // Retry failed
    retryFailedButton: 'Försök igen misslyckade',
    retryFailedConfirmTitle: 'Försök igen med misslyckade e-postmeddelanden',
    retryFailedConfirmMessage: (count: number) => `Du är på väg att försöka skicka till ${count} misslyckade mottagare igen. Fortsätta?`,
    confirmRetryButton: 'Försök igen',
    successRetry: (count: number) => `Försöker skicka ${count} misslyckade e-postmeddelande(n) igen...`
}

export const EmailCampaignPreviewMeta: EmailCampaignPreviewMetaProps = {
    title: 'E-postförhandsgranskning',
    closeButton: 'Stäng',
    backButton: 'Tillbaka till redigering',
    testWarningTitle: 'Test-e-postmeddelande',
    testWarningMessage: 'Denna banner kommer endast att visas i test-e-postmeddelanden. Den kommer inte att inkluderas i den faktiska kampanjen.'
}

export const ShiftMoveModalMeta: ShiftMoveModalMetaProps = {
    title: "Flytta volontär",
    submitButton: "Flytta",
    submittingButton: "Flyttar...",
    closeButton: "Avbryt",
    eventLabel: "Evenemang",
    areaLabel: "Område",
    shiftLabel: "Pass",
    eventPlaceHolder: "Välj evenemang",
    areaPlaceHolder: "Välj område",
    shiftPlaceHolder: "Välj pass"
}


export const VolunteerUploadDocumentFormMeta: VolunteerUploadDocumentFormMetaProps = {
    title: "Ladda upp dokument",
    cancelButton: "Avbryt",
    submitButton: "Ladda upp",
    submittingButton: "Laddar upp...",
    documentTypeLabel: "Dokumenttyp"
}

export const UPLOAD_DOCUMENT_TYPES = ["DBS (Standard)", "DBS (Utökad)", "Första hjälpen", "Läkarintyg"]

export const AllocationStatusPageMeta: AllocationStatusPageMetaProps = {
    title: 'Hantera uppgiftsacceptans',
    description: 'Visa och hantera volontärers status för att acceptera uppgifter, filtrera efter olika kriterier och omplacera volontärer vid behov.',
    backLink: '← Tillbaka till Admin Hub',
    // Status badges
    pendingLabel: 'Väntande',
    acceptedLabel: 'Accepterad',
    declinedLabel: 'Tackat nej',
    allLabel: 'Alla',
    // Filter labels
    filtersTitle: 'Filter',
    statusFilterLabel: 'Status',
    eventFilterLabel: 'Evenemang',
    areaFilterLabel: 'Område',
    shiftFilterLabel: 'Pass',
    volunteerSearchLabel: 'Sök volontär',
    volunteerSearchPlaceholder: 'Sök på namn, e-post eller ID...',
    declineReasonFilterLabel: 'Anledning till att tacka nej',
    dateRangeLabel: 'Svarsdatumintervall',
    dateFromLabel: 'Från',
    dateToLabel: 'Till',
    offeredAsTknLabel: 'Erbjuden som TKN',
    // Volunteer count filters
    volunteerCountsTitle: 'Filtrera efter antal volontärsvar',
    volunteerCountsEventsLabel: 'Räkna svar i evenemang:',
    volunteerCountsEventsAllLabel: 'Alla evenemang',
    minPendingCountLabel: 'Min väntande',
    maxPendingCountLabel: 'Max väntande',
    minAcceptedCountLabel: 'Min accepterad',
    maxAcceptedCountLabel: 'Max accepterad',
    minDeclinedCountLabel: 'Min tackat nej',
    maxDeclinedCountLabel: 'Max tackat nej',
    // Filter placeholders
    selectEventPlaceholder: 'Alla evenemang',
    selectAreaPlaceholder: 'Alla områden',
    selectShiftPlaceholder: 'Alla pass',
    selectDeclineReasonPlaceholder: 'Alla anledningar',
    // Actions
    searchButton: 'Sök',
    clearFiltersButton: 'Rensa filter',
    exportCsvButton: 'Exportera CSV',
    exportingButton: 'Exporterar...',
    // Table
    tableVolunteerColumn: 'Volontär',
    tableEventColumn: 'Evenemang',
    tableAreaColumn: 'Område',
    tableShiftColumn: 'Pass',
    tableStatusColumn: 'Status',
    tableTknColumn: 'TKN',
    tableDeclineReasonColumn: 'Anledning',
    tableResponseDateColumn: 'Svarsdatum',
    tableActionsColumn: 'Åtgärder',
    // Bulk actions
    bulkActionsTitle: 'Massåtgärder',
    selectedCountLabel: (count) => `${count} vald(a)`,
    changeStatusButton: 'Ändra status',
    reAllocateButton: 'Omplacera',
    setToPendingButton: 'Sätt till väntande',
    setToAcceptedButton: 'Sätt till accepterad',
    setToDeclinedButton: 'Sätt till tackat nej',
    // Messages
    noResultsMessage: 'Inga tilldelningar hittades som matchar dina kriterier.',
    loadingMessage: 'Laddar tilldelningar...',
    errorMessage: 'Ett fel uppstod vid inläsning av tilldelningar.',
    bulkUpdateSuccessMessage: (count) => `Uppdaterade framgångsrikt ${count} tilldelning(ar).`,
    bulkUpdateErrorMessage: 'Kunde inte uppdatera tilldelningar. Vänligen försök igen.',
    // Re-allocate modal
    reAllocateTitle: 'Omplacera volontär(er)',
    reAllocateDescription: 'Välj ett nytt pass att tilldela den/de valda volontären(erna). Detta skapar en ny tilldelning utan att påverka den ursprungliga.',
    reAllocateEventLabel: 'Evenemang',
    reAllocateAreaLabel: 'Område',
    reAllocateShiftLabel: 'Pass',
    reAllocateWarning: 'Obs: Den ursprungliga tilldelningen förblir oförändrad. Detta skapar en ny tilldelning med väntande status.',
    reAllocateDuplicateWarning: 'Varning: En eller flera volontärer har redan en tilldelning för detta pass.',
    reAllocateSubmitButton: 'Skapa ny tilldelning',
    reAllocatingButton: 'Skapar...',
    reAllocateCancelButton: 'Avbryt',
    reAllocateSuccessMessage: (count) => `Skapade framgångsrikt ${count} ny(a) tilldelning(ar).`,
    reAllocateErrorMessage: 'Kunde inte skapa nya tilldelningar. Vänligen försök igen.',
    // Pagination
    previousButton: 'Föregående',
    nextButton: 'Nästa',
    pageLabel: 'Sida',
    itemsPerPageLabel: 'Objekt per sida',
    totalItemsLabel: (count) => `${count} totala objekt`,
    // Decline reasons (copied from Home for consistency)
    declineReasons: [
        'Tiden passar inte (ett annat pass kan erbjudas, i mån av plats)',
        'Jag vill inte utföra just denna uppgift (ett annat pass kan erbjudas, i mån av plats)',
        'Kan inte engagera mig just nu (jag kommer att besöka VRC på dagen)',
        'Jag vill inte längre fortsätta på grund av personliga skäl'
    ],
    startTimeLabel: 'Starttid',
    endTimeLabel: 'Sluttid'
}

export const ALLOCATION_STATUS_OPTIONS = ["Accepted", "Declined", "Pending"]

export const CheckInPageMeta: CheckInPageMetaProps = {
    title: 'Volontärincheckning',
    description: 'Skanna volontärmärken eller sök på namn för att checka in dem för deras tilldelade uppgifter.',
    backToAdmin: 'Tillbaka till Admin',
    // Mode toggle
    scanModeLabel: 'Skanna märke',
    searchModeLabel: 'Sök',
    // Scanner input
    scannerPlaceholder: 'Skanna märke eller ange streckkod...',
    scannerLabel: 'Märkesskanner',
    scannerHint: 'Placera märkets streckkod framför skannern',
    // Search input
    searchPlaceholder: 'Sök på namn, e-post eller ID...',
    searchLabel: 'Sök volontär',
    searchHint: 'Ange minst 2 tecken för att söka',
    searchButton: 'Sök',
    searchingText: 'Söker...',
    searchResultsTitle: 'Sökresultat',
    noSearchResultsMessage: 'Inga volontärer hittades som matchar din sökning.',
    selectVolunteerButton: 'Välj',
    // Event filter
    eventFilterLabel: 'Välj evenemang',
    selectEventPrompt: 'Vänligen välj ett evenemang',
    // Volunteer display
    volunteerNotFoundMessage: 'Volontären hittades inte. Vänligen försök skanna igen.',
    loadingMessage: 'Letar upp volontär...',
    errorMessage: 'Ett fel uppstod. Vänligen försök igen.',
    scanToBeginMessage: 'Skanna ett volontärmärke för att påbörja incheckning',
    searchToBeginMessage: 'Sök efter en volontär via namn för att påbörja incheckning',
    // Volunteer card
    volunteerCardTitle: 'Volontärdetaljer',
    emailLabel: 'E-post',
    phoneLabel: 'Telefon',
    countryLabel: 'Land',
    jamatkhanaLabel: 'Jamatkhana',
    // Allocations
    allocationsTitle: 'Uppgiftstilldelningar',
    noAllocationsMessage: 'Inga uppgiftstilldelningar hittades för denna volontär.',
    noAllocationsForEventMessage: 'Inga tilldelningar för det valda evenemanget.',
    eventColumn: 'Evenemang',
    areaColumn: 'Område',
    shiftColumn: 'Pass',
    timeColumn: 'Tid',
    statusColumn: 'Acceptans',
    actionColumn: 'Incheckning',
    // Check-in status
    checkedInLabel: 'Incheckad',
    notCheckedInLabel: 'Inte incheckad',
    checkedInAtLabel: (time) => `Incheckad kl. ${time}`,
    checkedInByLabel: (name) => `av ${name}`,
    // Buttons
    checkInButton: 'Checka in',
    undoCheckInButton: 'Ångra',
    checkingInButton: 'Checkar in...',
    deallocateDutyButton: 'Ta bort',
    deallocatingDutyButton: 'Tar bort...',
    scanAnotherButton: 'Skanna nästa',
    allocateDutyButton: 'Tilldela uppgift',
    // Messages
    checkInSuccessMessage: 'Incheckning lyckades!',
    undoCheckInSuccessMessage: 'Incheckning ångrad.',
    deallocateDutyConfirmMessage: (dutyName) => `Ta bort ${dutyName} från denna volontär? Detta kan inte ångras.`,
    deallocateDutySuccessMessage: 'Uppgiften togs bort.',
    deallocateDutyErrorMessage: 'Kunde inte ta bort uppgiften. Försök igen.',
    checkInErrorMessage: 'Kunde inte checka in. Vänligen försök igen.',
    // Allocation status badges
    pendingStatusLabel: 'Väntande',
    acceptedStatusLabel: 'Accepterad',
    declinedStatusLabel: 'Tackat nej',
    // Camera scanning
    cameraScanButton: 'Använd kamera',
    cameraScannerTitle: 'Skanna märke med kamera',
    cameraScannerHint: 'Placera märkets streckkod i kameravyn',
    cameraPermissionDenied: 'Kameratillgång nekades. Vänligen tillåt kameratillgång för att använda denna funktion.',
    cameraNotSupported: 'Kameraskanning stöds inte på denna enhet.',
    closeCameraButton: 'Stäng',
    // Shift View mode
    shiftViewModeLabel: 'Passvy',
    shiftViewAreaLabel: 'Område',
    shiftViewShiftLabel: 'Pass',
    shiftViewSelectAreaPrompt: 'Välj ett område',
    shiftViewSelectShiftPrompt: 'Välj ett pass',
    shiftViewNoAreasMessage: 'Inga områden hittades för de valda evenemangen.',
    shiftViewNoShiftsMessage: 'Inga pass hittades för det valda området.',
    shiftViewLoadingVolunteers: 'Laddar volontärer...',
    shiftViewNoVolunteersMessage: 'Inga volontärer tilldelade detta pass.',
    shiftViewVolunteerCount: (checked, total) => `${checked}/${total} Incheckade`,
    shiftViewNameColumn: 'Namn',
    shiftViewPhoneColumn: 'Telefon',
    shiftViewTimeColumn: 'Tid',
    shiftViewStatusColumn: 'Status',
    shiftViewActionColumn: 'Åtgärd',
    // Create volunteer
    createVolunteerButton: "Kan inte hitta? Skapa här"
}

export const DutyStatusOverviewMeta: DutyStatusOverviewMetaProps = {
    title: "Statistik för uppgiftsacceptans",
    description: "Följande tabell är en uppdelning av uppgiftsacceptansstatus för publicerade pass.",
    errorTitle: "Misslyckades att hämta statistik.",
    loadingText: "Laddar...",
    eventSelectionLabel: "Välj evenemang att analysera"
}

export const QuickAllocateModalMeta: QuickAllocateModalMetaProps = {
    title: 'Snabb tilldelning av uppgift',
    subtitle: (volunteerName) => `Tilldela en uppgift till ${volunteerName}`,
    // Search
    searchPlaceholder: 'Sök pass eller områden...',
    // Sort options
    sortLabel: 'Sortera efter',
    sortByUrgency: 'Brådska',
    sortByStartTime: 'Starttid',
    sortByAlphabetical: 'Alfabetisk',
    // Stats labels
    requiredLabel: 'Krävs',
    acceptedLabel: 'Accepterad',
    checkedInLabel: 'Incheckad',
    // Shift display
    noShiftsMessage: 'Inga tillgängliga pass hittades för detta evenemang.',
    loadingShiftsMessage: 'Laddar pass...',
    viewOtherShiftsButton: (count) => `Visa andra pass (${count})`,
    hideOtherShiftsButton: 'Dölj andra pass',
    // Conflict labels
    alreadyAllocatedLabel: 'Redan tilldelad',
    timeConflictLabel: 'Tidskrock',
    // Buttons
    allocateButton: 'Tilldela',
    allocatingButton: 'Tilldelar...',
    cancelButton: 'Avbryt',
    closeButton: 'Stäng',
    // Messages
    allocationSuccessMessage: 'Uppgiften har tilldelats framgångsrikt!',
    allocationErrorMessage: 'Kunde inte tilldela uppgiften. Vänligen försök igen.'
}

export const LiveOperationsMeta: LiveOperationsMetaProps = {
    title: "Live-evenemangsdrift",
    description: 'Övervaka volontärers närvaro i realtid, passtÄckning och kritiska operativa mätvärden.',
    errorTitle: 'Fel',
    areaCheckBoxTitle: 'Välj områden',
    areaCheckBoxLabel: 'Välj områden från pass som ska visas',
    shiftsMeta: { title: 'Tillgängliga pass', description: 'Följande pass kräver volontärstöd' }
}

export const LIVE_OPERATIONS_TABS: { key: LiveStatusTab, header: string }[] = [
    { key: "checkin-stats", header: "Incheckningar" },
    { key: "shifts", header: "Brådskande pass" },
]

export const LoginFormMeta: LoginFormMetaProps = {
    title: 'Icke-IIUK Inloggning',
    emailLabel: 'E-post',
    emailPlaceholder: 'namn@foretag.com',
    passwordLabel: 'Lösenord',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Glömt ditt lösenord?',
    loginButton: 'Logga in',
    createAccount: 'Skapa ett konto',
    errorLabel: 'Fel:',
    sending: 'Skickar...',
    resendVerification: 'Skicka verifieringsmail igen',
    travelInfo: 'Om du redan planerar att resa och vill vara volontär, vänligen registrera ditt intresse. Volontärarbete bygger på personliga arrangemang, och alla resor, boende, visum och relaterade krav måste ordnas självständigt.'
}

export const ForgetPasswordMeta: ForgetPasswordMetaProps = {
    back: 'Tillbaka',
    errorLabel: 'Fel:',
    successLabel: 'Lyckades!',
    successMessage: 'Kontrollera din e-postinkorg (och skräppostmapp) för länken till lösenordsåterställning.',
    title: 'Glömt lösenord',
    emailLabel: 'E-post',
    emailPlaceholder: 'du@exempel.com',
    sendResetLink: 'Skicka återställningslänk'
}

export const ResetPasswordMeta: ResetPasswordMetaProps = {
    errorLabel: 'Fel:',
    successLabel: 'Lyckades!',
    title: 'Återställ lösenord',
    passwordLabel: 'Lösenord',
    passwordPlaceholder: 'Nytt lösenord',
    confirmPasswordLabel: 'Bekräfta lösenord',
    confirmPasswordPlaceholder: 'Bekräfta nytt lösenord',
    resetting: 'Återställer...',
    resetButton: 'Återställ lösenord',
    invalidLinkError: 'Länken för lösenordsåterställning är ogiltig eller har gått ut.',
    passwordsDoNotMatch: 'Lösenorden matchar inte.',
    missingTokenError: 'Saknar token eller e-post. Använd länken från ditt e-postmeddelande.'
}

export const SignupMeta: SignupMetaProps = {
    checkEmailTitle: 'Kontrollera din e-post',
    checkEmailMessage: 'Vi har skickat en verifieringslänk till din e-postadress. Klicka på länken för att verifiera ditt konto.',
    checkEmailHint: 'Fick du inte e-postmeddelandet? Kontrollera din skräppostmapp. Verifieringslänken upphör efter 60 minuter.',
    travelInfo: 'Om du redan planerar att resa och vill vara volontär, vänligen registrera ditt intresse. Volontärarbete bygger på personliga arrangemang, och alla resor, boende, visum och relaterade krav måste ordnas självständigt.',
    accountInfoTitle: 'Kontoinformation',
    emailPlaceholder: 'E-postadress',
    passwordPlaceholder: 'Lösenord',
    rePasswordPlaceholder: 'Ange lösenord igen',
    volunteerInfoTitle: 'Volontärinformation',
    firstNamePlaceholder: 'Förnamn',
    lastNamePlaceholder: 'Efternamn',
    selectGender: 'Välj kön',
    male: 'Man',
    female: 'Kvinna',
    preferNotToSay: 'Föredrar att inte svara',
    countryCodePlaceholder: 'Landskod t.ex: +46',
    phonePlaceholder: 'Telefonnummer',
    countryPlaceholder: 'Land',
    jamatkhanaPlaceholder: 'Jamatkhana',
    familyOriginLabel: 'Familjeursprung',
    selectOrigin: 'Välj ursprung',
    additionalDetailsTitle: 'Ytterligare uppgifter',
    ismaili: 'Ismaili',
    interFaithFamily: 'Interreligiös familj',
    languagesLabel: 'Språk',
    supportNeedsPlaceholder: 'Eventuella ytterligare stödbehov…',
    registerButton: 'Registrera',
    registering: 'Registrerar…',
    passwordsDoNotMatch: 'Lösenorden matchar inte.',
    faithStatusRequired: 'Välj antingen Ismaili eller Interreligiös familj.',
    invalidDob: 'Ange ett giltigt födelsedatum.'
}

export const VerifyEmailMeta: VerifyEmailMetaProps = {
    title: 'E-postverifiering',
    verifying: 'Verifierar din e-post...',
    successTitle: 'E-post verifierad!',
    successMessage: 'Tack för att du registrerade dig som volontär för besöket i Storbritannien.',
    reviewMessage: 'Din volontärregistrering granskas för närvarande.',
    approvalNotice: 'Du kommer att få ett e-postmeddelande när din registrering har godkänts av vårt team.',
    travelInfo: 'Om du redan planerar att resa och vill vara volontär, vänligen registrera ditt intresse. Volontärarbete bygger på personliga arrangemang, och alla resor, boende, visum och relaterade krav måste ordnas självständigt.',
    backToLogin: 'Tillbaka till inloggning',
    backToSignup: 'Tillbaka till registrering',
    sending: 'Skickar...',
    resendVerification: 'Skicka verifieringsmail igen',
    invalidLinkError: 'Ogiltig verifieringslänk. Kontrollera länken i ditt e-postmeddelande.'
}

export const HouseholdSelectionMeta: HouseholdSelectionMetaProps = {
    errorTitle: 'Fel',
    returnToLogin: 'Tillbaka till inloggning',
    title: 'Välj hushållsmedlem',
    description: 'Välj vilken medlem i ditt hushåll du vill använda plattformen som.',
    youBadge: 'Du',
    cancel: 'Avbryt',
    loadError: 'Kunde inte ladda hushållsmedlemmar. Försök logga in igen.'
}

export const CheckInLoginFormMeta: CheckInLoginFormMetaProps = {
    errorLabel: 'Fel:',
    title: 'Inloggning för incheckning',
    usernameLabel: 'Användarnamn',
    usernamePlaceholder: 'Ange ditt användarnamn',
    passwordLabel: 'Lösenord',
    passwordPlaceholder: 'Ange ditt lösenord',
    loginButton: 'Logga in'
}


export const ApprovedCountries = [
    'Austria',
    'Germany',
    'Italy',
    'Poland',
    'Denmark',
    'Finland',
    'Netherlands',
    'Norway',
    'Sweden',
    'Bulgaria',
    'Czech Republic',
    'Estonia',
    'Greece',
    'Hungary',
    'Latvia',
    'Lithuania',
    'Malta',
    'North Macedonia',
    'Romania',
    'Slovakia',
    'Slovenia',
    'North Cyprus',
    'Turkey',
    //'Türkiye',
]


export const EU_JAMAT_KHANA_OPTIONS = [
    'amsterdam',
    'bad salzuflen',
    'berlin',
    'bologna',
    'bosel',
    'bulgaria',
    'cologne',
    'copenhagen',
    'czech',
    'dresden',
    'eindhoven',
    'erfurt',
    'essen',
    'estonia',
    'frankfurt',
    'gothenburg',
    'graz',
    'greece',
    'hamburg',
    'helsinki',
    'hungary',
    'kassel',
    'krakow',
    'latvia',
    'leipzig',
    'linz',
    'lithuania',
    'ljungby',
    'malmo',
    'malta',
    'munich',
    'nicosia',
    'north macedonia',
    'orebro',
    'oslo',
    'romania',
    'rome',
    'rotterdam',
    'rzeszow',
    'slovakia',
    'slovenia',
    'stockholm',
    'stuttgart',
    'szczecin',
    'turkey',
    'umea',
    'vanersborg',
    'vienna',
    'warsaw',
    'wuppertal',
    'zevenaar',
];

export const GuidelineFormModalMeta: GuidelineFormModalMetaProps = {
    title: 'Skapa riktlinje',
    nameLabel: 'Namn',
    namePlaceholder: 'Namn...',
    descriptionLabel: 'Beskrivning',
    descriptionPlaceholder: 'beskrivning...',
    audienceLabel: 'Vem kan se denna riktlinje?',
    audienceAllOption: 'Välj alla',
    audienceServiceRecordOption: 'Välj IV-positioner',
    addModuleButton: 'Lägg till innehåll',
    noModulesMessage: 'Inget innehåll tillgängligt',
    uploadButton: 'Spara riktlinje',
    uploadingLabel: 'Sparar...',
    cancelButton: 'Avbryt',
    submitButton: 'Skicka',
    submittingButton: 'Skickar...'
}

export const AdminGuidelinesMeta: AdminGuidelinesMetaProps = {
    title: 'Riktlinjer',
    description: 'Hantera referensriktlinjer för volontärer',
    errorTitle: 'Fel',
    noGuidelinesMessage: 'Inga riktlinjer ännu',
    loadingText: 'Laddar...'
}

export const VolunteerGuidelinesMeta: VolunteerGuidelinesMetaProps = {
    title: 'Riktlinjer',
    errorTitle: 'Fel',
    noGuidelinesMessage: 'Inga riktlinjer tillgängliga',
    documentsLabel: 'dokument'
}

export const GuidelineDetailsMeta: GuidelineDetailsMetaProps = {
    backButtonLabel: 'Tillbaka till riktlinjer',
    errorTitle: 'Fel',
    notFoundMessage: 'Riktlinjen hittades inte'
}

export const DirectorVolunteerMeta: DirectorVolunteerMetaProps = {
    title: "Jamat Khana-volontärer",
    description: "Visa volontärer från din jamat khana"
}



